import { useState, useEffect, useRef, useContext } from "react";
import Split from "react-split";
import axios from "axios";
import { FaCircle, FaRegFolderOpen } from "react-icons/fa";
import Select from "react-select";
import { SlOptionsVertical } from "react-icons/sl";
import FunLogo from "../images/functionapp.png";
import { RiSwap2Fill } from "react-icons/ri";
import WebLogo from "../images/appservice.png";
import SqlLogo from "../images/sqlserver.png";
import MySqlImg from "../images/mysql.png";
import PostgresqlImg from "../images/postgresql.png";
import VmLogo from "../images/virtualmachine.png";
import kubernetes from "./../images/Kubernetes-Services.svg";
import lgLogo from "../images/logicapp.png";
// import { FaCircle, FaRegFolderOpen } from "react-icons/fa";
import { Table, Container } from "react-bootstrap";
import "./../css/ready.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WebSocketContext from "./../context/WebSocketContext";
import "tippy.js/dist/tippy.css";
import { RiGlobalLine } from "react-icons/ri";
import DatabaseModal from "./DatabaseModal";
// import { FaLink } from "react-icons/fa6";
import { Tooltip } from "react-tippy";
import "react-tippy/dist/tippy.css";
// import { BsDatabaseFillCheck } from "react-icons/bs";
import SpinnerSquare from "./SpinnerSquare";
import DrStepper from "./DrStepper";
import { Popover, OverlayTrigger } from "react-bootstrap";
import ec2 from "./../images/ec2.png";
import RDS from "./../images/RDS.png";
import Lambda from "./../images/Lambda.png";
import beanStalk from "./../images/beanStalk.png";
import eks from "./../images/kubernetes.png";
import SQL from "./../images/cloud_sql.png";
import ComputeEngine from "./../images/gcomputeeng.png";
import CloudFunction from "./../images/gcloudfn.png";
import gke from "./../images/gke.png";
import { fetchRtoData } from "../services/apiService";

const TwoCardSlider = ({
  activeKey,
  setTabs,
  setSelectedResourceGroup,
  tabId,
}) => {
  const [primaryData, setPrimaryData] = useState([]);
  const [fnAppData, setFnAppData] = useState([]);
  const [fnAppRightData, setFnAppRightData] = useState([]);
  const [webAppData, setWebAppData] = useState([]);
  const [webAppRightData, setWebAppRightData] = useState([]);
  const [sqlData, setSqlData] = useState([]);
  const [sqlRightData, setSqlRightData] = useState([]);
  const [mySqlData, setMySqlData] = useState([]);
  const [mySqlRightData, setMySqlRightData] = useState([]);
  const [postgresqlData, setPostgresqlData] = useState([]);
  const [postgresqlRightData, setPostgresqlRightData] = useState([]);
  const [vmData, setVmData] = useState([]);
  const [vmRightData, setVmRightData] = useState([]);
  const [logicData, setLogicData] = useState([]);
  const [logicRightData, setLogicRightData] = useState([]);
  const [kubernetesData, setKubernetesData] = useState([]);
  const [kubernetesRightData, setKubernetesRightData] = useState([]);
  const [secondaryData, setSecondaryData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [isFailoverActive, setIsFailoverActive] = useState(false);
  const [leftWidth, setLeftWidth] = useState(50); // Default left width percentage
  const [loading, setLoading] = useState(false);
  const [projectListLoading, setProjectListLoading] = useState(false);
  const { socketData, clearSocketData } = useContext(WebSocketContext);
  const [payload, setPayload] = useState(null);
  const [scriptPayload, setScriptPayload] = useState(null);
  const [selectedSqlCount, setSelectedSqlCount] = useState(0);
  const [selectedVmCount, setSelectedVmCount] = useState(0);
  const [selectedFnAppCount, setSelectedFnAppCount] = useState(0);
  const [selectedAppServiceCount, setSelectedAppServiceCount] = useState(0);
  const [selectedLogicAppCount, setSelectedLogicAppCount] = useState(0);
  const [selectedKubernetesCount, setSelectedKubernetesCount] = useState(0);
  const [sqlResponseCount, setSqlResponseCount] = useState(0);
  const [vmResponseCount, setVmResponseCount] = useState(0);
  const [fnAppResponseCount, setFnAppResponseCount] = useState(0);
  const [appServiceResponseCount, setAppServiceResponseCount] = useState(0);
  const [logicAppResponseCount, setLogicAppResponseCount] = useState(0);
  const [kubernetesResponseCount, setKubernetesResponseCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [rtoData, setRtoData] = useState(null);
  // const processedEventIds = useRef(new Set()); // Track processed event IDs
  const processedResourcesRef = useRef(new Set());

  const provider = localStorage.getItem("provider");
  console.log(provider, "provider");

  const API_URL = `${
    process.env.REACT_APP_API_BASE_URL
  }/cloud/${provider?.toLowerCase()}/initiate-dr/resources`;
  const FAIL_URL = `${
    process.env.REACT_APP_API_BASE_URL
  }/cloud/${provider?.toLowerCase()}/initiate-fo`;
  const FAIL_URL_SCRIPT = `${
    process.env.REACT_APP_API_BASE_URL
  }/cloud/${provider?.toLowerCase()}/failover-script/execute`;
  const RESOURCE_GROUP_URL = `${
    process.env.REACT_APP_API_BASE_URL
  }/cloud/${provider?.toLowerCase()}/project-name-list`;

  const [selectedValue, setSelectedValue] = useState("");

  const [resourceGroup, setResourceGroup] = useState([]);

  const fetchResourceGroupList = async () => {
    setProjectListLoading(true);
    await axios.get(RESOURCE_GROUP_URL).then((res) => {
      console.log(res?.data?.data?.data, "resssss");
      setResourceGroup(res?.data?.data?.data);
      const indexFind = res?.data?.data?.data;
      const projectGroup =
        provider.toLowerCase() === "azure"
          ? "az-fb-rg-DRD"
          : provider.toLowerCase() === "aws"
          ? "drd-dev-1"
          : "DRD-Project";
      const selectedIndex = indexFind.findIndex(
        (project) => project?.name === projectGroup
      );
      console.log(selectedIndex, "selectedIndex");

      // const defaultValue = indexFind[selectedIndex]?.name;
      const defaultValue =
        selectedIndex !== -1
          ? indexFind[selectedIndex]?.name
          : indexFind[0]?.name;
      setSelectedValue(defaultValue);
    });
    setProjectListLoading(false);
  };
  console.log(resourceGroup, "selectedvalue");

  console.log(tabId, "tabId");
  console.log(activeKey, "activeKey");

  useEffect(() => {
    fetchResourceGroupList();
    // eslint-disable-next-line
  }, []);

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
    // Find the corresponding projectName from the resourceGroup
    const selectedOption = resourceGroup.find(
      (option) => option?.name === event.target.value
    );

    if (selectedOption) {
      setSelectedResourceGroup(selectedOption?.projectName); // Set the selected projectName in state
    }
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.id === activeKey
          ? { ...tab, title: selectedOption?.projectName || "Tag-Undefined" }
          : tab
      )
    );
  };

  const getDataBase = async (serverNames, projectName, dbType) => {
    if (
      !serverNames ||
      (Array.isArray(serverNames) && serverNames.length === 0)
    ) {
      console.warn("No server names provided. Skipping API call.");
      return [];
    }
    try {
      const subscriptionId = "d6240a3c-34a4-4a5c-955b-06228bf34ca8";
      // Ensure serverNames is always an array
      const serverArray = Array.isArray(serverNames)
        ? serverNames
        : [serverNames];
      const serverQueryParam = encodeURIComponent(JSON.stringify(serverArray));
      let basePath = "";
      if (dbType === "mssql") basePath = "azureMsSql";
      else if (dbType === "mysql") basePath = "azureMySql";
      else if (dbType === "postgresql") basePath = "azurePostgreSql";

      const url = `https://devwebsocket.drtestdash.com/dbList/${basePath}?subscriptionId=${subscriptionId}&resourceGroupName=${projectName}&servers=${serverQueryParam}`;

      const response = await axios.get(url);
      const result = [];

      for (const server of serverArray) {
        const dbList = response?.data?.[server];

        if (Array.isArray(dbList)) {
          result.push({
            server,
            databases: dbList.map((dbName) => ({
              name: dbName,
              status: "Available",
            })),
          });
        } else {
          result.push({
            server,
            databases: [],
          });
        }
      }
      return result;
    } catch (error) {
      console.error(
        `Failed to fetch databases for servers: ${serverNames}`,
        error
      );
      return [];
    }
  };

  const fetchData = async (failOver = false) => {
    if (!failOver) {
      setLoading(true); // Show loader only if failOver is false
    }
    try {
      // Primary API Call
      const response = await axios.get(API_URL, {
        params: {
          projectName: selectedValue,
        },
      });

      // Parsing Primary Data
      const sqlServer =
        response?.data?.data["active-passive-resources"]?.sqlServerss || [];
      const functionApps =
        response?.data?.data["active-passive-resources"]?.functionAppss || [];
      const appServices =
        response?.data?.data["active-passive-resources"]?.appServicess || [];

      const vms = (
        response?.data?.data["active-passive-resources"]?.vms || []
      ).map((vm) => ({
        id: vm?.recoveryVmInfo?.id,
        name: vm?.name,
        type: "virtualmachine",
        location: vm?.location,
        vmseclocation: vm?.recoveryVmInfo?.recoveryFabricLocation || "Unknown",
        recoveryInfo: vm?.recoveryVmInfo?.recoveryVmName || "N/A",
        recoveryVmInfo: vm?.recoveryVmInfo || "NA",
        replicationRole: vm?.state?.split("/")[1] || "Unknown",
        networkId: vm?.recoveryVmInfo?.recoveryAzureNetworkId,
        instanceType: vm?.recoveryVmInfo?.instanceType,
        ipAddress: vm?.ipAddress,
      }));

      const sql = sqlServer.map((sqlServer) => ({
        id: sqlServer?.id,
        projectName: sqlServer?.resourceGroupTags?.Name,
        name: sqlServer?.name,
        type: "sqlservers",
        serverName: sqlServer?.serverName,
        location: sqlServer?.location,
        recoveryInfo: "N/A",
        replicationRole:
          sqlServer?.failOverGroups?.[0]?.properties?.replicationRole || "N/A",
        fname: sqlServer?.failOverGroups?.[0]?.name || "N/A",
        partnerServer:
          sqlServer?.failOverGroups?.[0]?.properties?.partnerServers?.[0]?.id,
        dataBase: sqlServer.failOverGroups?.[0]?.properties?.databases,
      }));

      // Handle Primary Function Apps and App Services
      const primaryFunctionApps = parsePrimaryFunctionApps(functionApps);

      const primaryAppServices = parsePrimaryAppServices(appServices);

      const secondaryFunctionApps = parseSecondaryFunctionApps(functionApps);
      const secondaryAppServices = parseSecondaryAppServices(appServices);

      const anSqlServer =
        response?.data?.data["active-nothing-resources"]?.dbServer || [];
      const serverNames = anSqlServer.map((server) => server.name);
      const getDatabases = await getDataBase(
        serverNames,
        selectedValue,
        "mssql"
      );

      // MySQL Flexible Server
      const mysqlServer =
        response?.data?.data["active-nothing-resources"]?.mysqlFlexibleServer ||
        [];
      const mysqlServerNames = mysqlServer.map((server) => server.name);
      const mysqlDatabases = await getDataBase(
        mysqlServerNames,
        selectedValue,
        "mysql"
      );

      // PostgreSQL Flexible Server
      const postgreServer =
        response?.data?.data["active-nothing-resources"]
          ?.postgreSqlFlexibleServer || [];
      const postgreServerNames = postgreServer.map((server) => server.name);
      const postgreDatabases = await getDataBase(
        postgreServerNames,
        selectedValue,
        "postgresql"
      );
      const primaryNothingResources = [
        ...(
          response?.data?.data["active-nothing-resources"]
            ?.serverlessComputing || []
        ).map((fnApp) => ({
          id: fnApp.id,
          name: fnApp?.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "functionapp"
              : provider?.toLowerCase() === "aws"
              ? fnApp.type
              : fnApp.type
          }`,
          location: fnApp?.location,
          replicationRole: fnApp?.state,
          rowCheck: true,
          targetUrl: Array.isArray(fnApp?.hostNames)
            ? fnApp?.hostNames[0]
            : null,
          checkDis: false,
          checkHide: false,
        })),
        ...(
          response?.data?.data["active-nothing-resources"]?.appHosting || []
        ).map((appService) => ({
          id: appService.id,
          name: appService.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "appservice"
              : provider?.toLowerCase() === "aws"
              ? appService.type
              : appService.type
          }`,
          location: appService.location,
          replicationRole: appService.state,
          rowCheck: true,
          targetUrl: Array.isArray(appService?.hostNames)
            ? appService?.hostNames[0]
            : null,
          checkDis: false,
          checkHide: false,
        })),
        ...(
          response?.data?.data["active-nothing-resources"]?.dbServer || []
        ).map((sqlServer) => ({
          id: sqlServer.id,
          name: sqlServer.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "sqlservers"
              : provider?.toLowerCase() === "aws"
              ? sqlServer.type
              : sqlServer.type
          }`,
          location: sqlServer.location,
          replicationRole: sqlServer.state,
          rowCheck: true,
          dataBases:
            getDatabases.find((entry) => entry.server === sqlServer.name)
              ?.databases || [],
        })),
        ...(
          response?.data?.data["active-nothing-resources"]
            ?.mysqlFlexibleServer || []
        ).map((sqlServer) => ({
          id: sqlServer.id,
          name: sqlServer.name,
          type: "mysql server",
          location: sqlServer.location,
          replicationRole: sqlServer.state,
          rowCheck: true,
          dataBases:
            mysqlDatabases.find((entry) => entry.server === sqlServer.name)
              ?.databases || [],
        })),
        ...(
          response?.data?.data["active-nothing-resources"]
            ?.postgreSqlFlexibleServer || []
        ).map((sqlServer) => ({
          id: sqlServer.id,
          name: sqlServer.name,
          type: "postgresql server",
          location: sqlServer.location,
          replicationRole: sqlServer.state,
          rowCheck: true,
          dataBases:
            postgreDatabases.find((entry) => entry.server === sqlServer.name)
              ?.databases || [],
        })),
        ...(
          response?.data?.data["active-nothing-resources"]?.computeService || []
        ).map((vms) => ({
          id: vms.id,
          name: vms.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "virtualmachine"
              : provider?.toLowerCase() === "aws"
              ? vms.type
              : vms.type
          }`,
          location: vms.location,
          replicationRole:
            vms.state === "PowerState/deallocated"
              ? "Stopped"
              : vms.state === "PowerState/running"
              ? "Running"
              : vms.state,
          rowCheck: true,
          ipAddress: vms?.ipAddress,
          checkDis: false,
          checkHide: false,
        })),
        ...(
          response?.data?.data["active-nothing-resources"]
            ?.serverlessWorkFlow || []
        ).map((lgApp) => ({
          id: lgApp.id,
          name: lgApp?.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "logicapp"
              : provider?.toLowerCase() === "aws"
              ? lgApp.type
              : lgApp.type
          }`,
          location: lgApp?.location,
          replicationRole:
            lgApp?.state === "Enabled"
              ? "Running"
              : lgApp?.state === "Disabled"
              ? "Stopped"
              : lgApp?.state,
          rowCheck: true,
          checkDis: false,
          checkHide: false,
        })),
        ...(
          response?.data?.data["active-nothing-resources"]?.kubernetesService ||
          []
        ).map((kgService) => ({
          id: kgService.id,
          name: kgService?.name,
          type: `${
            provider?.toLowerCase() === "azure"
              ? "kubernetes"
              : provider?.toLowerCase() === "aws"
              ? kgService.type
              : kgService.type
          }`,
          location: kgService?.location,
          replicationRole: kgService?.state,
          rowCheck: true,
          checkDis: false,
          checkHide: false,
        })),
      ];

      console.log(primaryNothingResources, "primaryNothingResources");

      // Setting Primary Data
      setPrimaryData([
        ...primaryFunctionApps,
        ...primaryAppServices,
        ...sql,
        ...vms,
        ...primaryNothingResources,
      ]);

      const fnAppFilter = primaryNothingResources.filter(
        (item) =>
          item?.type?.toLowerCase() ===
          `${
            provider?.toLowerCase() === "azure"
              ? "functionapp"
              : provider?.toLowerCase() === "aws"
              ? "lambda"
              : "cloudfunction"
          }`
      );
      const webAppFilter = primaryNothingResources.filter(
        (item) =>
          item?.type ===
          `${
            provider?.toLowerCase() === "azure"
              ? "appservice"
              : provider?.toLowerCase() === "aws"
              ? "elasticbeanstalk"
              : ""
          }`
      );
      const sqlFilter = primaryNothingResources.filter(
        (item) =>
          item?.type?.toLowerCase() ===
          `${
            provider?.toLowerCase() === "azure"
              ? "sqlservers"
              : provider?.toLowerCase() === "aws"
              ? "rds"
              : "sql"
          }`
      );

      const vmFilter = primaryNothingResources.filter(
        (item) =>
          item?.type?.toLowerCase() ===
          `${
            provider?.toLowerCase() === "azure"
              ? "virtualmachine"
              : provider?.toLowerCase() === "aws"
              ? "ec2"
              : "computeengine"
          }`
      );

      const lgAppFilter = primaryNothingResources.filter(
        (item) =>
          item?.type?.toLowerCase() ===
          `${
            provider?.toLowerCase() === "azure"
              ? "logicapp"
              : provider?.toLowerCase() === "aws"
              ? "stepfunctions"
              : "Workflow"
          }`
      );

      const kubernetesFilter = primaryNothingResources.filter(
        (item) =>
          item?.type ===
          `${
            provider?.toLowerCase() === "azure"
              ? "kubernetes"
              : provider?.toLowerCase() === "aws"
              ? "eks"
              : "gke"
          }`
      );
      const mysqlFilter = primaryNothingResources.filter(
        (item) => item?.type === "mysql server"
      );
      const postgresqlFilter = primaryNothingResources.filter(
        (item) => item?.type === "postgresql server"
      );

      setFnAppData([...primaryFunctionApps, ...fnAppFilter]);
      setWebAppData([...primaryAppServices, ...webAppFilter]);
      setSqlData([...sql, ...sqlFilter]);
      setVmData([...vms, ...vmFilter]);
      setLogicData(lgAppFilter);
      setKubernetesData(kubernetesFilter);
      setMySqlData(mysqlFilter);
      setPostgresqlData(postgresqlFilter);
      // setFnAppRightData(secondaryFunctionApps);
      // setWebAppRightData(secondaryAppServices);
      setSecondaryData([...secondaryFunctionApps, ...secondaryAppServices]);

      // Process Secondary SQL Failover Group
      const failOverGroups = sqlServer
        .flatMap((sql) => sql.failOverGroups)
        .filter(Boolean);

      if (failOverGroups.length > 0) {
        for (const failOverGroup of failOverGroups) {
          const subscriptionId = "d6240a3c-34a4-4a5c-955b-06228bf34ca8";
          const projectName = extractResourceGroupName(
            failOverGroup.properties.partnerServers?.[0]?.id
          );
          await fetchSecondarySql(subscriptionId, projectName);
        }
      }

      // Process Secondary VM Recovery Info
      const recoveryVMs = vms.filter(
        (vm) =>
          typeof vm.recoveryVmInfo === "object" &&
          vm.recoveryVmInfo !== null &&
          Object.keys(vm.recoveryVmInfo).length > 0
      );
      console.log(recoveryVMs, "recoveryVMs");

      if (recoveryVMs.length > 0) {
        for (const recoveryVM of recoveryVMs) {
          const projectName =
            recoveryVM.recoveryVmInfo.recoveryAzureResourceGroupId;
          await fetchSecondaryVM(projectName, vms);
        }
      }
      if (selectedValue) {
        await fetchSecondaryNothingResources(
          selectedValue,
          primaryNothingResources
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  console.log(fnAppData, "fnAppData");
  console.log(webAppData, "webAppData");
  console.log(sqlData, "sqlData");

  const parsePrimaryFunctionApps = (functionApps) => {
    return functionApps.flatMap((fnApp) => {
      // Extract the target ID from endpoints with source === false
      const targetEndpoint = fnApp.endPoint
        .filter((endpoint) => endpoint.source === false)
        .map((endpoint) => ({
          targetId: endpoint.id,
        }));
      // Map the source === true endpoints and include the targetId if available
      return fnApp.endPoint
        .filter((endpoint) => endpoint.source === true)
        .map((endpoint, index) => ({
          id: endpoint.id,
          endpointStatus: endpoint.properties.endpointStatus,
          name: endpoint.name,
          type: "functionapp",
          location: endpoint.properties.endpointLocation,
          replicationRole: endpoint.properties.endpointStatus || "Unknown",
          priority: endpoint.properties?.priority,
          targetId: targetEndpoint[index]?.targetId || null, // Add targetId from the filtered target endpoint
          targetUrl: endpoint.properties.target,
        }));
    });
  };

  const parseSecondaryFunctionApps = (functionApps) => {
    return functionApps.flatMap((fnApp) => {
      // Extract the target ID from endpoints with source === false
      const targetEndpoint = fnApp.endPoint
        .filter((endpoint) => endpoint.source === true)
        .map((endpoint) => ({
          targetId: endpoint.id,
        }));
      // Map the source === true endpoints and include the targetId if available
      return fnApp.endPoint
        .filter((endpoint) => endpoint.source === false)
        .map((endpoint, index) => ({
          id: endpoint.id,
          endpointStatus: endpoint.properties.endpointStatus,
          name: endpoint.name,
          type: "functionapp",
          location: endpoint.properties.endpointLocation,
          replicationRole: endpoint.properties.endpointStatus || "Unknown",
          priority: endpoint.properties?.priority,
          targetId: targetEndpoint[index]?.targetId || null, // Add targetId from the filtered target endpoint
          targetUrl: endpoint.properties.target,
        }));
    });
  };

  // Parsing primary AppServices
  const parsePrimaryAppServices = (appServices) => {
    return appServices.flatMap((appServ) => {
      // Extract targetId from source === false endpoints
      const targetEndpoint = appServ.endPoint
        .filter((endpoint) => endpoint.source === false)
        .map((endpoint) => ({
          targetId: endpoint.id,
        }));

      // Map the source === true endpoints and add the targetId if available
      return appServ.endPoint
        .filter((endpoint) => endpoint.source === true)
        .map((endpoint, index) => ({
          id: endpoint.id,
          endpointStatus: endpoint.properties.endpointStatus,
          name: endpoint.name,
          type: "appservice",
          location: endpoint.properties.endpointLocation,
          replicationRole: endpoint.properties.endpointStatus || "Unknown",
          priority: endpoint.properties?.priority,
          targetId: targetEndpoint[index]?.targetId || null, // Add targetId from the target endpoint
          targetUrl: endpoint.properties.target,
        }));
    });
  };

  // Parsing secondary AppServices
  const parseSecondaryAppServices = (appServices) => {
    return appServices.flatMap((appServ) => {
      // Extract targetId from source === true endpoints
      const targetEndpoint = appServ.endPoint
        .filter((endpoint) => endpoint.source === true)
        .map((endpoint) => ({
          targetId: endpoint.id,
        }));

      // Map the source === false endpoints and add the targetId if available
      return appServ.endPoint
        .filter((endpoint) => endpoint.source === false)
        .map((endpoint, index) => ({
          id: endpoint.id,
          endpointStatus: endpoint.properties.endpointStatus,
          name: endpoint.name,
          type: "appservice",
          location: endpoint.properties.endpointLocation,
          replicationRole: endpoint.properties.endpointStatus || "Unknown",
          priority: endpoint.properties?.priority,
          targetId: targetEndpoint[index]?.targetId || null, // Add targetId from the target endpoint
          targetUrl: endpoint.properties.target,
        }));
    });
  };

  const extractResourceGroupName = (partnerServerId) => {
    const parts = partnerServerId?.split("/") || [];
    return parts[4] || "Unknown";
  };

  const fetchSecondarySql = async (projectName) => {
    try {
      const response = await axios.get(API_URL, {
        params: { projectName },
      });
      if (response.data?.status === "Success") {
        const secondarySqlServers =
          response.data?.data["active-passive-resources"]?.sqlServers || [];
        setSecondaryData((prev) => [
          ...prev,
          ...secondarySqlServers.map((sqlServer) => ({
            id: sqlServer?.id,
            name: sqlServer?.name,
            serverName: sqlServer?.serverName,
            projectName: sqlServer?.resourceGroupTags?.Name,
            type: "sqlservers",
            location: sqlServer?.location,
            fname: sqlServer?.failOverGroups?.[0]?.name || "N/A",
            replicationRole:
              sqlServer?.failOverGroups?.[0]?.properties?.replicationRole ||
              "N/A",
            partnerServer:
              sqlServer?.failOverGroups?.[0]?.properties?.partnerServers?.[0]
                ?.id,
            dataBase: sqlServer?.failOverGroups?.[0]?.properties?.databases,
          })),
        ]);
        setSqlRightData(() => [
          ...secondarySqlServers.map((sqlServer) => ({
            id: sqlServer?.id,
            name: sqlServer?.name,
            serverName: sqlServer?.serverName,
            projectName: sqlServer?.resourceGroupTags?.Name,
            type: "sqlservers",
            location: sqlServer?.location,
            fname: sqlServer?.failOverGroups?.[0]?.name || "N/A",
            replicationRole:
              sqlServer?.failOverGroups?.[0]?.properties?.replicationRole ||
              "N/A",
            partnerServer:
              sqlServer?.failOverGroups?.[0]?.properties?.partnerServers?.[0]
                ?.id,
            dataBase: sqlServer?.failOverGroups?.[0]?.properties?.databases,
          })),
        ]);
      }
    } catch (error) {
      console.error("Error fetching secondary SQL data:", error);
    }
  };

  const fetchSecondaryVM = async (projectName, primaryVMs) => {
    try {
      const response = await axios.get(API_URL, {
        params: { projectName },
      });
      if (response.data?.status === "Success") {
        const secondaryVMs =
          response?.data?.data["active-passive-resources"]?.vm || [];
        const processedVMs =
          secondaryVMs.length > 0
            ? secondaryVMs.map((vm) => ({
                id: vm.recoveryVmInfo?.id || "Vmid", // Fallback ID
                name: vm.name || "Unnamed VM", // Fallback name
                type: "virtualmachine" || "Unknown Type", // Fallback type
                location: vm.location || "Unknown Location", // Fallback location
                replicationRole: vm.state?.split("/")[1] || "Stopped", // Default replication role
                recoveryVmInfo: vm.recoveryVmInfo || "NA",
                ipAddress: vm.ipAddress,
              }))
            : primaryVMs.map((vm) => ({
                ...vm,
                id: "Vmid",
                location: vm.vmseclocation,
                replicationRole: "Stopped",
              }));

        // Update secondary data
        setSecondaryData((prev) => [...prev, ...processedVMs]);
        setVmRightData([...processedVMs]);
      }
    } catch (error) {
      console.error("Error fetching secondary VM data:", error);
    }
  };

  const fetchSecondaryNothingResources = async (
    resourceGroupNameNo,
    primaryNothingResources
  ) => {
    try {
      let trimmedName = resourceGroupNameNo;

      // Remove existing suffix if present
      if (trimmedName.endsWith("-CUS-DR")) {
        trimmedName = trimmedName.slice(0, -11);
      } else if (trimmedName.endsWith("-dr")) {
        trimmedName = trimmedName.slice(0, -4);
      }

      // Determine correct suffix
      const suffixName =
        provider.toLowerCase() === "azure"
          ? "-CUS-DR"
          : provider.toLowerCase() === "aws"
          ? "-dr"
          : "-drdd";

      // If original name had the suffix, we trimmed it and return only trimmedName
      // Else, we append the correct suffix
      const hadSuffix =
        resourceGroupNameNo.endsWith("-CUS-DR") ||
        resourceGroupNameNo.endsWith("-dr");

      const projectName = hadSuffix
        ? trimmedName
        : `${trimmedName}${suffixName}`;

      const response = await axios.get(API_URL, {
        params: { projectName },
      });

      if (response.data?.status === "Success") {
        let secondaryNothingResources = [];

        const fnApp =
          response?.data?.data["active-nothing-resources"]
            ?.serverlessComputing || [];
        const webApp =
          response?.data?.data["active-nothing-resources"]?.appHosting || [];
        const sqlServer =
          response?.data?.data["active-nothing-resources"]?.dbServer || [];
        const mySqlServer =
          response?.data?.data["active-nothing-resources"]
            ?.mysqlFlexibleServer || [];
        const postgrSqlServer =
          response?.data?.data["active-nothing-resources"]
            ?.postgreSqlFlexibleServer || [];
        const vm =
          response?.data?.data["active-nothing-resources"]?.computeService ||
          [];
        const lgApp = Array.isArray(
          response?.data?.data["active-nothing-resources"]?.serverlessWorkFlow
        )
          ? response.data.data["active-nothing-resources"].serverlessWorkFlow
          : [];
        const kubernetes =
          response?.data?.data["active-nothing-resources"]?.kubernetesService ||
          [];

        const suffixName =
          provider?.toLowerCase() === "azure"
            ? "-cus-dr"
            : provider?.toLowerCase() === "aws"
            ? "-dr"
            : "-drdd";

        // Handle function apps
        if (!fnApp.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "functionapp"
                      : provider?.toLowerCase() === "aws"
                      ? "lambda"
                      : "cloudFunction"
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "functionapp"
                    : provider?.toLowerCase() === "aws"
                    ? "lambda"
                    : "cloudFunction"
                }`,
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
              }))
          );
        } else {
          // Push matched resources from webApp into secondaryNothingResources
          const matchedResources = fnApp?.filter((fnApp) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "functionapp"
                      : provider?.toLowerCase() === "aws"
                      ? "lambda"
                      : "cloudFunction"
                  }` && `${primaryItem.name}${suffixName}` === fnApp.name
            )
          );
          console.log(matchedResources, "fnMatched");

          if (matchedResources.length) {
            console.log("fnChecked");

            secondaryNothingResources.push(
              ...matchedResources.map((fnApp) => ({
                name: fnApp.name,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "functionapp"
                    : provider?.toLowerCase() === "aws"
                    ? "lambda"
                    : "cloudFunction"
                }`,
                location: fnApp.location,
                replicationRole: fnApp.state,
                rowCheck: true,
                checkDis: true,
                targetUrl: Array.isArray(fnApp?.hostNames)
                  ? fnApp?.hostNames[0]
                  : null,
              }))
            );

            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}${suffixName}` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "functionapp"
                  : provider?.toLowerCase() === "aws"
                  ? "lambda"
                  : "cloudFunction"
              }`
            ) {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "functionapp"
                      : provider?.toLowerCase() === "aws"
                      ? "lambda"
                      : "cloudFunction"
                  }`,
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Handle app services
        if (!webApp.length) {
          // If webApp is empty, add all primaryNothingResources
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "appservice"
                      : provider?.toLowerCase() === "aws"
                      ? "elasticbeanstalk"
                      : ""
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}-cus-dr`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "appservice"
                    : provider?.toLowerCase() === "aws"
                    ? "elasticbeanstalk"
                    : ""
                }`,
                location: "centralus",
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
              }))
          );
        } else {
          // Push matched resources from webApp into secondaryNothingResources
          const matchedResources = webApp?.filter((webAppItem) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "appservice"
                      : provider?.toLowerCase() === "aws"
                      ? "elasticbeanstalk"
                      : ""
                  }` && `${primaryItem.name}-cus-dr` === webAppItem.name
            )
          );

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((webAppItem) => ({
                name: webAppItem.name,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "appservice"
                    : provider?.toLowerCase() === "aws"
                    ? "elasticbeanstalk"
                    : ""
                }`,
                location: webAppItem.location,
                replicationRole: webAppItem.state,
                rowCheck: true,
                checkDis: true,
                targetUrl: Array.isArray(webAppItem?.hostNames)
                  ? webAppItem?.hostNames[0]
                  : null,
              }))
            );
            // Set checkHide: true for corresponding primary items
            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}-cus-dr` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "appservice"
                  : provider?.toLowerCase() === "aws"
                  ? "elasticbeanstalk"
                  : ""
              }`
            ) {
              const expectedName = `${primaryItem.name}-cus-dr`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "appservice"
                      : provider?.toLowerCase() === "aws"
                      ? "elasticbeanstalk"
                      : ""
                  }`,
                  location: "centralus",
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Handle SQL servers
        if (!sqlServer.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "sqlservers"
                      : provider?.toLowerCase() === "aws"
                      ? "rds"
                      : "sql"
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "sqlservers"
                    : provider?.toLowerCase() === "aws"
                    ? "rds"
                    : "sql"
                }`,
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
                dbDis: true,
                dataBases: resource?.dataBases.map((item) => ({
                  name: item.name,
                  status: "-",
                })),
              }))
          );
        } else {
          const serverNames = sqlServer.map((server) => server.name);
          const getDatabases = await getDataBase(
            serverNames,
            projectName,
            "mssql"
          );
          const matchedResources = sqlServer?.filter((sqlServ) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "sqlservers"
                      : provider?.toLowerCase() === "aws"
                      ? "rds"
                      : "sql"
                  }` && `${primaryItem.name}${suffixName}` === sqlServ.name
            )
          );
          console.log(matchedResources, "fnMatched");

          if (matchedResources.length) {
            console.log("fnChecked");

            secondaryNothingResources.push(
              ...matchedResources.map((sqlServ) => {
                const foundDbEntry = getDatabases.find(
                  (entry) => entry.server === sqlServ.name
                );

                const databasesFromGet = foundDbEntry?.databases || [];

                // Extract original name without suffix (e.g., remove "-cus-dr")
                const originalName = sqlServ.name.replace(suffixName, "");

                // Find the corresponding primary resource
                const fallbackPrimary = primaryNothingResources.find(
                  (item) =>
                    `${item.name}` === originalName &&
                    item.type ===
                      (provider?.toLowerCase() === "azure"
                        ? "sqlservers"
                        : provider?.toLowerCase() === "aws"
                        ? "rds"
                        : "sql")
                );
                const fallbackDatabases = fallbackPrimary?.dataBases || [];

                const existingDbNames = new Set(
                  databasesFromGet.map((db) => db.name)
                );

                const missingDatabases = fallbackDatabases
                  .filter((db) => !existingDbNames.has(db.name))
                  .map((db) => ({
                    name: db.name,
                    status: "not yet created",
                  }));

                console.log(missingDatabases, "missingDatabases");
                const finalDatabases = [
                  ...databasesFromGet,
                  ...missingDatabases,
                ];

                // Use fallback databases if `databasesFromGet` is empty
                // const finalDatabases =
                //   databasesFromGet.length > 0
                //     ? databasesFromGet
                //     : fallbackPrimary?.dataBases?.map((item) => ({
                //         name: item.name,
                //         status: "not yet created",
                //       })) || [];

                return {
                  name: sqlServ.name,
                  type:
                    provider?.toLowerCase() === "azure"
                      ? "sqlservers"
                      : provider?.toLowerCase() === "aws"
                      ? "rds"
                      : "sql",
                  location: sqlServ.location,
                  replicationRole: sqlServ.state,
                  rowCheck: true,
                  checkDis: true,
                  dbDis: true,
                  dataBases: finalDatabases,
                };
              })
            );

            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}${suffixName}` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "sqlservers"
                  : provider?.toLowerCase() === "aws"
                  ? "rds"
                  : "sql"
              }`
            ) {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "sqlservers"
                      : provider?.toLowerCase() === "aws"
                      ? "rds"
                      : "sql"
                  }`,
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                  dbDis: true,
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Handle VMs
        if (!vm.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "virtualmachine"
                      : provider?.toLowerCase() === "aws"
                      ? "ec2"
                      : "computeEngine"
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "virtualmachine"
                    : provider?.toLowerCase() === "aws"
                    ? "ec2"
                    : "computeEngine"
                }`,
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
              }))
          );
        } else {
          console.log("vmChecked");

          // Push matched resources from webApp into secondaryNothingResources
          const matchedResources = vm?.filter((vm) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "virtualmachine"
                      : provider?.toLowerCase() === "aws"
                      ? "ec2"
                      : "computeEngine"
                  }` && `${primaryItem.name}${suffixName}` === vm.name
            )
          );

          console.log(matchedResources, "vmMatched");

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((vm) => ({
                name: vm?.name,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "virtualmachine"
                    : provider?.toLowerCase() === "aws"
                    ? "ec2"
                    : "computeEngine"
                }`,
                location: vm?.location,
                replicationRole:
                  vm?.state === "PowerState/deallocated"
                    ? "Stopped"
                    : vm?.state === "PowerState/running"
                    ? "Running"
                    : vm?.state,
                rowCheck: true,
                checkDis: true,
                ipAddress: vm?.ipAddress,
              }))
            );
            matchedResources.forEach((matchedItem) => {
              const isTerminated =
                matchedItem?.state?.toLowerCase() === "terminated";

              const primaryItem = primaryNothingResources.find(
                (primary) =>
                  `${primary.name}${suffixName}` === matchedItem.name &&
                  !isTerminated
              );

              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "virtualmachine"
                  : provider?.toLowerCase() === "aws"
                  ? "ec2"
                  : "computeEngine"
              }`
            ) {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "virtualmachine"
                      : provider?.toLowerCase() === "aws"
                      ? "ec2"
                      : "computeEngine"
                  }`,
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Handle logic apps
        if (!lgApp.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "logicapp"
                      : provider?.toLowerCase() === "aws"
                      ? "StepFunctions"
                      : ""
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}-cus-dr`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "logicapp"
                    : provider?.toLowerCase() === "aws"
                    ? "StepFunctions"
                    : ""
                }`,
                location: "centralus",
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
              }))
          );
        } else {
          // Push matched resources from webApp into secondaryNothingResources
          const matchedResources = lgApp?.filter((lgApp) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "logicapp"
                      : provider?.toLowerCase() === "aws"
                      ? "StepFunctions"
                      : ""
                  }` && `${primaryItem.name}-cus-dr` === lgApp.name
            )
          );

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((lgApp) => ({
                name: lgApp.name,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "logicapp"
                    : provider?.toLowerCase() === "aws"
                    ? "StepFunctions"
                    : ""
                }`,
                location: lgApp.location,
                replicationRole:
                  lgApp?.state === "Enabled"
                    ? "Running"
                    : lgApp?.state === "Disabled"
                    ? "Stopped"
                    : lgApp?.state,
                rowCheck: true,
                checkDis: true,
              }))
            );

            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}-cus-dr` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "logicapp"
                  : provider?.toLowerCase() === "aws"
                  ? "StepFunctions"
                  : ""
              }`
            ) {
              const expectedName = `${primaryItem.name}-cus-dr`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "logicapp"
                      : provider?.toLowerCase() === "aws"
                      ? "StepFunctions"
                      : ""
                  }`,
                  location: "centralus",
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Handle Kubernetes
        if (!kubernetes.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter(
                (item) =>
                  item.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "kubernetes"
                      : provider?.toLowerCase() === "aws"
                      ? "eks"
                      : "gke"
                  }`
              )
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "kubernetes"
                    : provider?.toLowerCase() === "aws"
                    ? "eks"
                    : "gke"
                }`,
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
              }))
          );
        } else {
          // Push matched resources from webApp into secondaryNothingResources
          const matchedResources = kubernetes?.filter((ksData) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "kubernetes"
                      : provider?.toLowerCase() === "aws"
                      ? "eks"
                      : "gke"
                  }` && `${primaryItem.name}${suffixName}` === ksData.name
            )
          );

          console.log(matchedResources, "vmMatched");

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((ksData) => ({
                name: ksData?.name,
                type: `${
                  provider?.toLowerCase() === "azure"
                    ? "kubernetes"
                    : provider?.toLowerCase() === "aws"
                    ? "eks"
                    : "gke"
                }`,
                location: ksData?.location,
                replicationRole: ksData?.state,
                rowCheck: true,
                checkDis: true,
              }))
            );
            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}${suffixName}` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (
              primaryItem.type ===
              `${
                provider?.toLowerCase() === "azure"
                  ? "kubernetes"
                  : provider?.toLowerCase() === "aws"
                  ? "eks"
                  : "gke"
              }`
            ) {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: `${
                    provider?.toLowerCase() === "azure"
                      ? "kubernetes"
                      : provider?.toLowerCase() === "aws"
                      ? "eks"
                      : "gke"
                  }`,
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        if (!mySqlServer.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter((item) => item.type === "mysql server")
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: "mysql server",
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
                dbDis: true,
                dataBases: resource?.dataBases.map((item) => ({
                  name: item.name,
                  status: "-",
                })),
              }))
          );
        } else {
          const serverNames = mySqlServer.map((server) => server.name);
          const getDatabases = await getDataBase(
            serverNames,
            projectName,
            "mysql"
          );
          const matchedResources = mySqlServer?.filter((sqlServ) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type === "mysql server" &&
                `${primaryItem.name}${suffixName}` === sqlServ.name
            )
          );

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((sqlServ) => {
                const foundDbEntry = getDatabases.find(
                  (entry) => entry.server === sqlServ.name
                );

                const databasesFromGet = foundDbEntry?.databases || [];

                // Extract original name without suffix (e.g., remove "-cus-dr")
                const originalName = sqlServ.name.replace(suffixName, "");

                // Find the corresponding primary resource
                const fallbackPrimary = primaryNothingResources.find(
                  (item) =>
                    `${item.name}` === originalName &&
                    item.type === "mysql server"
                );
                const fallbackDatabases = fallbackPrimary?.dataBases || [];

                const existingDbNames = new Set(
                  databasesFromGet.map((db) => db.name)
                );

                const missingDatabases = fallbackDatabases
                  .filter((db) => !existingDbNames.has(db.name))
                  .map((db) => ({
                    name: db.name,
                    status: "not yet created",
                  }));
                console.log(missingDatabases, "missingDatabases");
                const finalDatabases = [
                  ...databasesFromGet,
                  ...missingDatabases,
                ];

                return {
                  name: sqlServ.name,
                  type: "mysql server",
                  location: sqlServ.location,
                  replicationRole: sqlServ.state,
                  rowCheck: true,
                  checkDis: true,
                  dbDis: true,
                  dataBases: finalDatabases,
                };
              })
            );

            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}${suffixName}` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (primaryItem.type === "mysql server") {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: "mysql server",
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                  dbDis: true,
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }
        if (!postgrSqlServer.length) {
          secondaryNothingResources.push(
            ...primaryNothingResources
              ?.filter((item) => item.type === "postgresql server")
              ?.map((resource) => ({
                name: `${resource.name}${suffixName}`,
                type: "postgresql server",
                location: `${
                  provider?.toLowerCase() === "azure"
                    ? "centralus"
                    : provider?.toLowerCase() === "aws"
                    ? "us-west-1"
                    : "us-central1-b"
                }`,
                rowCheck: true,
                checkDis: true,
                replicationRole: "-",
                dbDis: true,
                dataBases: resource?.dataBases.map((item) => ({
                  name: item.name,
                  status: "-",
                })),
              }))
          );
        } else {
          const serverNames = postgrSqlServer.map((server) => server.name);
          const getDatabases = await getDataBase(
            serverNames,
            projectName,
            "postgresql"
          );
          const matchedResources = postgrSqlServer?.filter((sqlServ) =>
            primaryNothingResources.some(
              (primaryItem) =>
                primaryItem.type === "postgresql server" &&
                `${primaryItem.name}${suffixName}` === sqlServ.name
            )
          );

          if (matchedResources.length) {
            secondaryNothingResources.push(
              ...matchedResources.map((sqlServ) => {
                const foundDbEntry = getDatabases.find(
                  (entry) => entry.server === sqlServ.name
                );

                const databasesFromGet = foundDbEntry?.databases || [];

                // Extract original name without suffix (e.g., remove "-cus-dr")
                const originalName = sqlServ.name.replace(suffixName, "");

                // Find the corresponding primary resource
                const fallbackPrimary = primaryNothingResources.find(
                  (item) =>
                    `${item.name}` === originalName &&
                    item.type === "postgresql server"
                );
                const fallbackDatabases = fallbackPrimary?.dataBases || [];

                const existingDbNames = new Set(
                  databasesFromGet.map((db) => db.name)
                );

                const missingDatabases = fallbackDatabases
                  .filter((db) => !existingDbNames.has(db.name))
                  .map((db) => ({
                    name: db.name,
                    status: "not yet created",
                  }));
                console.log(missingDatabases, "missingDatabases");
                const finalDatabases = [
                  ...databasesFromGet,
                  ...missingDatabases,
                ];

                return {
                  name: sqlServ.name,
                  type: "postgresql server",
                  location: sqlServ.location,
                  replicationRole: sqlServ.state,
                  rowCheck: true,
                  checkDis: true,
                  dbDis: true,
                  dataBases: finalDatabases,
                };
              })
            );

            matchedResources.forEach((matchedItem) => {
              const primaryItem = primaryNothingResources.find(
                (primary) => `${primary.name}${suffixName}` === matchedItem.name
              );
              if (primaryItem) {
                primaryItem.checkHide = true;
              }
            });
          }

          // Ensure missing resources are placed in the correct index
          primaryNothingResources.forEach((primaryItem, primaryIndex) => {
            if (primaryItem.type === "postgresql server") {
              const expectedName = `${primaryItem.name}${suffixName}`;

              // Check if the resource is already in secondaryNothingResources
              const isAlreadyPlaced = secondaryNothingResources.some(
                (secondaryItem) => secondaryItem.name === expectedName
              );

              if (!isAlreadyPlaced) {
                // Resource is missing, add it in the correct index
                secondaryNothingResources.splice(primaryIndex, 0, {
                  name: expectedName,
                  type: "postgresql server",
                  location: `${
                    provider?.toLowerCase() === "azure"
                      ? "centralus"
                      : provider?.toLowerCase() === "aws"
                      ? "us-west-1"
                      : "us-central1-b"
                  }`,
                  rowCheck: true,
                  checkDis: true,
                  replicationRole: "-", // Default replicationRole for missing resources
                  dbDis: true,
                });
              }
            }
          });

          console.log(secondaryNothingResources, "secondaryNothingResources");
        }

        // Update state with the merged values
        setSecondaryData((prevData) => [
          ...prevData,
          ...secondaryNothingResources,
        ]);
        const fnAppRightFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "functionapp"
                : provider?.toLowerCase() === "aws"
                ? "lambda"
                : "cloudFunction"
            }`
        );
        const webAppRightFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "appservice"
                : provider?.toLowerCase() === "aws"
                ? "elasticbeanstalk"
                : ""
            }`
        );
        const sqlRightFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "sqlservers"
                : provider?.toLowerCase() === "aws"
                ? "rds"
                : "sql"
            }`
        );
        const mySqlRightFilter = secondaryNothingResources.filter(
          (item) => item?.type === "mysql server"
        );
        const postgreSqlRightFilter = secondaryNothingResources.filter(
          (item) => item?.type === "postgresql server"
        );
        const vmFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "virtualmachine"
                : provider?.toLowerCase() === "aws"
                ? "ec2"
                : "computeEngine"
            }`
        );
        const lgAppRightFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "logicapp"
                : provider?.toLowerCase() === "aws"
                ? "StepFunctions"
                : ""
            }`
        );
        const kubernetesRightFilter = secondaryNothingResources.filter(
          (item) =>
            item?.type ===
            `${
              provider?.toLowerCase() === "azure"
                ? "kubernetes"
                : provider?.toLowerCase() === "aws"
                ? "eks"
                : "gke"
            }`
        );

        setFnAppRightData(fnAppRightFilter);
        setWebAppRightData(webAppRightFilter);
        setSqlRightData(sqlRightFilter);
        setVmRightData(vmFilter);
        setLogicRightData(lgAppRightFilter);
        setKubernetesRightData(kubernetesRightFilter);
        setMySqlRightData(mySqlRightFilter);
        setPostgresqlRightData(postgreSqlRightFilter);
      }
    } catch (error) {
      console.error("Error fetching secondary nothing resources:", error);
    }
  };

  console.log(fnAppRightData, "fnAppRightData");
  console.log(webAppRightData, "webAppRightData");
  console.log(sqlRightData, "sqlRightData");
  console.log(vmRightData, "vmRightData");
  console.log(kubernetesRightData, "kubernetesRightData");

  useEffect(() => {
    if (resourceGroup.length > 0) {
      fetchData();
    }
    // eslint-disable-next-line
  }, [selectedValue]);
  console.log(secondaryData, "mkdsnjd");

  const updateStateBasedOnSocket = (socketData) => {
    if (!socketData?.data || !socketData?.data?.appEventTypeDetail?.action)
      return;

    const { topic, data } = socketData;
    console.log(topic, "updatedValue");

    const newReplicationRow = socketData?.data?.appEventTypeDetail?.action;
    const resourceName = data?.name?.toLowerCase();

    // Extract the last part of the topic (resource name)
    const topicResourceName = topic?.toLowerCase();

    const LambdaEventType = socketData?.eventType;
    const preventStopping = LambdaEventType === "aws.lambda/lambda-fn/event";
    const dbEventCreatingType =
      LambdaEventType === "microsoft.sql/servers/databases/export/action";
    const dbeventCompletedType =
      LambdaEventType === "microsoft.sql/servers/databases/import/action";
    const isCreateComplete = dbEventCreatingType || dbeventCompletedType;
    // Define a mapping between topics and states
    const stateMap = {
      fnAppTopic: { data: fnAppData, setData: setFnAppData },
      fnAppRightTopic: { data: fnAppRightData, setData: setFnAppRightData },
      webAppTopic: { data: webAppData, setData: setWebAppData },
      webAppRightTopic: { data: webAppRightData, setData: setWebAppRightData },
      sqlTopic: { data: sqlData, setData: setSqlData },
      sqlRightTopic: { data: sqlRightData, setData: setSqlRightData },
      vmTopic: { data: vmData, setData: setVmData },
      vmRightTopic: { data: vmRightData, setData: setVmRightData },
      lgTopic: { data: logicData, setData: setLogicData },
      lgRightTopic: { data: logicRightData, setData: setLogicRightData },
      kubernetesTopic: { data: kubernetesData, setData: setKubernetesData },
      kubernetesRightTopic: {
        data: kubernetesRightData,
        setData: setKubernetesRightData,
      },
    };
    // Iterate through all states to find a match
    Object.values(stateMap).forEach(({ data, setData }) => {
      const updatedData = data.map((item) => {
        if (newReplicationRow?.toLocaleLowerCase() === "update") return item;
        if (Object.keys(selectedRow).length === 0 && item?.type === "eks")
          return item;
        const itemIdMatch =
          item?.id &&
          topicResourceName &&
          item.id.toLowerCase() === topicResourceName;
        const itemNameMatch =
          item?.name &&
          resourceName &&
          item.name.toLowerCase() === resourceName;
        const constructedNameMatch =
          (
            item?.name +
            (provider.toLowerCase() === "azure"
              ? "-cus-dr"
              : provider.toLowerCase() === "aws"
              ? "-dr"
              : "-drdd")
          ).toLowerCase() === resourceName && !preventStopping;
        const getNotyetCreatedDb = item?.dataBases?.some(
          (db) => db.status === "not yet created"
        );

        console.log(getNotyetCreatedDb, "getNotyetCreatedDb");

        const checkDbCreation = isCreateComplete && getNotyetCreatedDb;
        console.log(checkDbCreation, "checkDbCreation");

        if (itemIdMatch || itemNameMatch || constructedNameMatch) {
          console.log(
            itemIdMatch,
            itemNameMatch,
            constructedNameMatch,
            "testCheck"
          );
          const suffix =
            provider.toLowerCase() === "azure"
              ? "-cus-dr"
              : provider.toLowerCase() === "aws"
              ? "-dr"
              : "-drdd";
          const fullConstructedName = (item?.name + suffix).toLowerCase();

          // Prevent updates when creating and constructed name matches
          if (
            newReplicationRow?.toLowerCase() === "creating" &&
            fullConstructedName === resourceName
          ) {
            return item;
          }

          console.log(item, "testItems");
          const isSqlType = item?.type === "sqlservers" || item?.type === "gke";
          const status = newReplicationRow?.toLowerCase();
          const isAzure = provider?.toLowerCase() === "azure";
          const isAws = provider?.toLowerCase() === "aws";
          const awsStatusCheck =
            LambdaEventType === "aws.ec2/instance/state-change"
              ? "running"
              : LambdaEventType === "aws.rds/db-instance/event"
              ? "started"
              : "created";
          const createdOnce = isAzure ? "created" : awsStatusCheck;

          // Trigger toast only once per update
          if (
            status === awsStatusCheck &&
            !processedResourcesRef.current.has(resourceName) &&
            Object.keys(selectedRow).length > 0
          ) {
            toast.success(`Resource ${resourceName} created successfully!`);
            processedResourcesRef.current.add(resourceName);
          }
          const hasSelectedRow = Object.keys(selectedRow).some(
            (key) => key?.toLowerCase() === topicResourceName?.toLowerCase()
          );

          const trimName =
            item.name +
              (isAzure ? "-cus-dr" : isAws ? "-dr" : "-drdd").toLowerCase() ===
            resourceName;
          const lambdaType = LambdaEventType === "aws.lambda/lambda-fn/event";
          const isEksType = LambdaEventType === "aws.eks/eks-cluster/event";

          let statusUpdate;

          if (status === "started" && !trimName) {
            statusUpdate = "Running";
          } else if (status === createdOnce && !trimName) {
            if (!lambdaType && !isSqlType && !isEksType) {
              statusUpdate = "Running";
            } else if (lambdaType || isEksType) {
              statusUpdate = "Active";
            } else if (isSqlType) {
              statusUpdate = "Ready";
            }
          } else if (status === createdOnce && trimName) {
            if (!isSqlType) {
              statusUpdate = "Stopping...";
            } else if (isSqlType) {
              statusUpdate = item?.replicationRole;
            }
          } else {
            statusUpdate = newReplicationRow;
          }

          return {
            ...item,
            replicationRole: statusUpdate,
            checkDis: hasSelectedRow || trimName ? true : item.checkDis,
            checkHide: Object.keys(selectedRow).length > 0,
          };
        }
        if (checkDbCreation) {
          console.log("correct logic for creation");
          const updateDbState = item.dataBases.map((db) => {
            const matchedSocket = resourceName === db?.name;
            return {
              ...db,
              status: matchedSocket ? newReplicationRow : db.status,
            };
          });

          return {
            ...item,
            dataBases: updateDbState,
          };
        }
        return item;
      });

      // Check if any update happened before setting the new state
      if (JSON.stringify(updatedData) !== JSON.stringify(data)) {
        setData(updatedData);
        console.log(updatedData, "socketUpdate");
      }
    });
  };

  useEffect(
    () => {
      if (socketData) {
        updateStateBasedOnSocket(socketData);

        const eventType = socketData?.eventType;
        const statusSql = socketData?.data?.appEventTypeDetail?.action;
        const subId = socketData?.topic;
        console.log(eventType, "eventType");
        console.log(statusSql, "statusSql");
        const isLambdaType = "aws.lambda/lambda-fn/event";
        const isKubernetesType = "aws.eks/eks-cluster/event";
        const isSqlType = "microsoft.sql/servers/write";

        const isCreated = "created";

        if (
          isLambdaType === eventType &&
          isCreated === statusSql.toLowerCase()
        ) {
          setFnAppResponseCount((prev) => prev + 1);
        }
        if (isSqlType === eventType && isCreated === statusSql.toLowerCase()) {
          setSqlResponseCount((prev) => prev + 1);
        }
        if (
          isKubernetesType === eventType &&
          isCreated === statusSql.toLowerCase()
        ) {
          setKubernetesResponseCount((prev) => prev + 1);
        }
        const selectedIds = Object.keys(selectedRow).filter(
          (id) => selectedRow[id]
        );
        console.log(selectedIds, "selectedIds");

        const processMatchedResources = (resources, setResponseCount) => {
          console.log(resources, "resourcesSet");

          const matchedResources = resources?.filter(
            (resourceName) =>
              socketData?.data?.name === resourceName &&
              statusSql?.toLocaleLowerCase() === "stopped"
          );

          console.log("Matched Resources:", matchedResources);

          if (matchedResources?.length && tabId === activeKey) {
            matchedResources.forEach((resource) => {
              // toast.success(`Resource ${resource} created successfully!`);
              setResponseCount((prev) => prev + 1);
            });
          }
        };

        // Process Web Apps
        processMatchedResources(
          scriptPayload?.webApps,
          setAppServiceResponseCount
        );

        // Process Function Apps
        processMatchedResources(
          provider.toLowerCase() === "azure"
            ? scriptPayload?.functionApps
            : scriptPayload?.lamdaIds,
          setFnAppResponseCount
        );

        processMatchedResources(
          provider.toLowerCase() === "azure"
            ? scriptPayload?.virtualMachines
            : provider.toLowerCase() === "aws"
            ? scriptPayload?.ec2Ids
            : scriptPayload?.gceIds,
          setVmResponseCount
        );

        processMatchedResources(
          provider.toLowerCase() === "azure"
            ? scriptPayload?.sqlServers
            : provider.toLowerCase() === "aws"
            ? scriptPayload?.rdsIds
            : scriptPayload?.sqlIds,
          setSqlResponseCount
        );

        processMatchedResources(
          scriptPayload?.logicApps,
          setLogicAppResponseCount
        );
        // Process Kubernetes
        processMatchedResources(
          provider.toLowerCase() === "azure"
            ? scriptPayload?.kubernetes
            : provider.toLowerCase() === "aws"
            ? scriptPayload?.eksIds
            : scriptPayload?.gkeIds,
          setKubernetesResponseCount
        );

        // Check for SQL failover action success
        // if (
        //   eventType ===
        //     "microsoft.sql/servers/failovergroups/failover/action" &&
        //   statusSql === "Succeeded" &&
        //   tabId === activeKey
        // ) {
        //   setSqlResponseCount((prev) => prev + 1);
        //   toast.success("SQL Failover completed successfully!");
        // }

        // // Check for VM failover action success
        // if (
        //   operationName === "Microsoft.Compute/virtualMachines/write" &&
        //   status === "Succeeded" &&
        //   tabId === activeKey
        // ) {
        //   setVmResponseCount((prev) => prev + 1);
        //   toast.success("VM Failover completed successfully!");
        // }
        // Check for Function App failover action success
        if (
          eventType ===
            "microsoft.network/trafficmanagerprofiles/azureendpoints/write" &&
          statusSql === "Succeeded" &&
          tabId === activeKey
        ) {
          // Check if subject contains "functionapp"
          if (subId && subId.includes("functionapp") && tabId === activeKey) {
            setFnAppResponseCount((prev) => prev + 1);
            toast.success("Function App Failover completed successfully!");
          }

          // Check if subject contains "webapp"
          else if (subId && subId.includes("webapp") && tabId === activeKey) {
            setAppServiceResponseCount((prev) => prev + 1);
            toast.success("App Service Failover completed successfully!");
          }
        }
      }
    }, // eslint-disable-next-line
    [socketData]
  );

  useEffect(() => {
    const handleApiResponses = async () => {
      if (
        sqlResponseCount === selectedSqlCount &&
        vmResponseCount === selectedVmCount &&
        fnAppResponseCount === selectedFnAppCount &&
        appServiceResponseCount === selectedAppServiceCount &&
        logicAppResponseCount === selectedLogicAppCount &&
        kubernetesResponseCount === selectedKubernetesCount &&
        (selectedSqlCount > 0 ||
          selectedVmCount > 0 ||
          selectedFnAppCount > 0 ||
          selectedAppServiceCount > 0 ||
          selectedLogicAppCount > 0 ||
          selectedKubernetesCount > 0)
      ) {
        console.log("Muthu");
        try {
          // setProgress(100);

          // Wait for 7 seconds before fetching data
          setSelectedRow(() => ({}));
          await new Promise((resolve) => setTimeout(resolve, 20000));
          setIsFailoverActive(false);

          await fetchData(true); // Ensure data is fetched after the delay
          setSqlResponseCount(0);
          setVmResponseCount(0);
          setFnAppResponseCount(0);
          setAppServiceResponseCount(0);
          setLogicAppResponseCount(0);
          setSelectedSqlCount(0);
          setSelectedVmCount(0);
          setSelectedFnAppCount(0);
          setSelectedAppServiceCount(0);
          setSelectedLogicAppCount(0);
          clearSocketData();
          setScriptPayload(null);
          // processedEventIds.current.clear();
          // window.location.reload();
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    };

    handleApiResponses();
    // eslint-disable-next-line
  }, [
    sqlResponseCount,
    vmResponseCount,
    fnAppResponseCount,
    appServiceResponseCount,
    logicAppResponseCount,
    kubernetesResponseCount,
    selectedSqlCount,
    selectedVmCount,
    selectedFnAppCount,
    selectedAppServiceCount,
    selectedLogicAppCount,
    selectedKubernetesCount,
  ]);

  console.log({
    sqlResponseCount: "sqlResponseCount",
    vmResponseCount: "vmResponseCount",
    fnAppResponseCount,
    appServiceResponseCount,
    selectedSqlCount,
    selectedVmCount,
    selectedFnAppCount,
    selectedAppServiceCount,
  });

  console.log(primaryData, "primary");
  console.log(JSON.stringify(socketData), "socketData");

  const handleCheckboxChange = (id, check) => {
    // console.log('filteredArray', functionApps?.filter(id));
    setSelectedRow((prev) => {
      console.log(prev[id], check);
      const updatedRows = {
        ...prev,
        [id]: !prev[id],
      };
      console.log(updatedRows, "updatedRows");

      const isAzure = provider.toLowerCase() === "azure";
      const isAws = provider.toLowerCase() === "aws";
      const isGcp = provider.toLowerCase() === "gcp";

      // Combine primary and secondary data
      const allData = [...primaryData, ...secondaryData];
      console.log(allData, "allData");

      const expectedTypeSql = isAzure
        ? "sqlservers"
        : isAws
        ? "rds"
        : isGcp
        ? "sql"
        : "";

      const sqlCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === expectedTypeSql
      ).length;

      const expectedTypeVm = isAzure
        ? "virtualmachine"
        : isAws
        ? "ec2"
        : isGcp
        ? "computeEngine"
        : "";

      const vmCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === expectedTypeVm
      ).length;

      const expectedTypeFn = isAzure
        ? "functionapp"
        : isAws
        ? "lambda"
        : isGcp
        ? "cloudFunction"
        : "";

      const fnAppCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === expectedTypeFn
      ).length;

      const appServiceCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === "appservice"
      ).length;

      const logicAppCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === "logicapp"
      ).length;

      const expectedTypeKubernetes =
        provider.toLowerCase() === "azure" ? "kubernetes" : "eks";

      const kubernetesCount = allData.filter(
        (item) => updatedRows[item.id] && item.type === expectedTypeKubernetes
      ).length;

      console.log(sqlCount, "sqlCount");
      console.log(vmCount, "vmCount");
      console.log(fnAppCount, "fnAppCount");
      console.log(appServiceCount, "appServiceCount");
      console.log(kubernetesCount, "kubernetesCount");

      setSelectedSqlCount(sqlCount);
      setSelectedVmCount(vmCount);
      setSelectedFnAppCount(fnAppCount);
      setSelectedAppServiceCount(appServiceCount);
      setSelectedLogicAppCount(logicAppCount);
      setSelectedKubernetesCount(kubernetesCount);

      // SQL Failover Request
      const sqlFailOverRequest = allData
        .filter(
          (item) =>
            updatedRows[item.id] && item.id && item.type === "sqlservers"
        )
        .map((sql) => {
          if (sql.partnerServer && typeof sql.partnerServer === "string") {
            const id = sql.partnerServer.split("/");
            const fname = sql.fname;

            return {
              resourceGroupName: id[4],
              sqlServerName: id[8],
              failOverGroupName: fname,
            };
          } else {
            console.error(
              "Invalid partnerServer or missing for SQL:",
              sql.partnerServer
            );
            return null;
          }
        })
        .filter((item) => item !== null);

      // const sqlFailOverRequest = allData
      //   .filter(
      //     (item) =>
      //       updatedRows[item.id] &&
      //       item.id === id &&
      //       item.type === "microsoft.sql/servers"
      //   )
      //   .map((sql) => ({
      //     resourceGroupName: sql.resourceGroupName,
      //     sqlServerName: sql.sqlServerName,
      //     failOverGroupName: sql.failOverGroupName,
      //   }));

      // VM Failover Request
      const vmFailOverRequest = allData
        .filter(
          (item) =>
            updatedRows[item.id] && item.id && item.type === "virtualmachine"
        )
        .map((vm) => ({
          failOverId: vm.id,
          failOverDirection: "PrimaryToRecovery",
          networkType: "VmNetworkAsInput",
          networkId: vm.networkId,
          instanceType: vm.instanceType,
        }));
      console.log(vmFailOverRequest, "vmFailOverRequest");

      const functionAppFailOverRequests = allData
        .filter(
          (item) =>
            updatedRows[item.id] && item.id && item.type === "functionapp"
        )
        .map((fnApp) => ({
          sourceEndpointStatus: "Disabled",
          sourceFunctionAppId: fnApp.id,
          targetEndpointStatus: "Enabled",
          targetFunctionAppId: fnApp.targetId,
        }));

      const webAppFailOverRequests = allData
        .filter(
          (item) =>
            updatedRows[item.id] &&
            item.id &&
            item.type === "appservice" &&
            !check
        )
        .map((appServ) => ({
          sourceEndpointStatus: "Disabled",
          sourceWebAppId: appServ.id,
          targetEndpointStatus: "Enabled",
          targetWebAppId: appServ.targetId,
        }));
      console.log(webAppFailOverRequests, "webAppFailOverRequests");

      // const webAppFailoverScriptRequest = allData
      //   .filter(
      //     (item) =>
      //       updatedRows[item.id] &&
      //       item.id &&
      //       item.type === "appservice" &&
      //       check
      //   )
      //   .reduce(
      //     (acc, appServ) => {
      //       if (!acc.subscriptionId) {
      //         acc.subscriptionId = "d6240a3c-34a4-4a5c-955b-06228bf34ca8";
      //         acc.resourceGroupName = selectedValue; // Ensure `selectedValue` is set to the appropriate value
      //         acc.resourceNames = [];
      //       }

      //       // Add app service name to resourceNames
      //       if (!acc.resourceNames.includes(appServ.name)) {
      //         acc.resourceNames.push(appServ.name);
      //       }

      //       return acc;
      //     },
      //     { subscriptionId: null, resourceGroupName: null, resourceNames: [] }
      //   );
      const anFailoverScriptRequest = allData
        .filter((item) => updatedRows[item.id] && item.id && check)
        .reduce(
          (acc, item) => {
            if (!acc.subscriptionId) {
              acc.subscriptionId = "d6240a3c-34a4-4a5c-955b-06228bf34ca8";
              acc.resourceGroupName = selectedValue; // Ensure `selectedValue` is set properly
              acc.targetRegion = "centralus";
              acc.resourceSuffix = "-cus-dr";
              acc.provider = provider.toLowerCase();
            }

            // Assign resources to the appropriate array
            if (
              item.type === "appservice" &&
              !acc.webApps.includes(item.name)
            ) {
              acc.webApps.push(item.name);
            } else if (
              item.type === "functionapp" &&
              !acc.functionApps.includes(item.name)
            ) {
              acc.functionApps.push(item.name);
            } else if (
              item.type === "virtualmachine" &&
              !acc.virtualMachines.includes(item.name)
            ) {
              acc.virtualMachines.push(item.name);
            } else if (
              item.type === "sqlservers" &&
              !acc.sqlServers.includes(item.name)
            ) {
              acc.sqlServers.push(item.name);
            } else if (
              item.type === "mysql server" &&
              !acc.mysqlServers.includes(item.name)
            ) {
              acc.mysqlServers.push(item.name);
            } else if (
              item.type === "postgresql server" &&
              !acc.postgresqlServers.includes(item.name)
            ) {
              acc.postgresqlServers.push(item.name);
            } else if (
              item.type === "logicapp" &&
              !acc.logicApps.includes(item.name)
            ) {
              acc.logicApps.push(item.name);
            } else if (
              item.type === "kubernetes" &&
              !acc.kubernetes.includes(item.name)
            ) {
              acc.kubernetes.push(item.name);
            }

            return acc;
          },
          {
            subscriptionId: null,
            resourceGroupName: null,
            targetRegion: null,
            resourceSuffix: null,
            webApps: [],
            functionApps: [],
            virtualMachines: [],
            sqlServers: [],
            mysqlServers: [],
            postgresqlServers: [],
            logicApps: [],
            kubernetes: [],
            provider: null,
          }
        );

      console.log(anFailoverScriptRequest, "anFailoverScriptRequest");

      const awsFailoverScriptRequest = allData
        .filter((item) => updatedRows[item.id] && item.id && check)
        .reduce(
          (acc, item) => {
            // Set general config only once
            if (!acc.provider) {
              acc.provider = "aws";
              acc.sourceRegion = item.location?.toLowerCase() || "us-east-2"; // fallback if location missing
              acc.targetRegion = "us-west-1"; // you can also make this dynamic if needed
              acc.resourceSuffix = "-dr";
              acc.projectName = item.projectName || "drd-dev-1";
            }
            console.log(item?.name, "itemName");

            // Push resources based on type
            if (item.type === "ec2" && !acc?.ec2Ids?.includes(item?.name)) {
              acc.ec2Ids.push(item.name);
            } else if (
              item.type === "rds" &&
              !acc?.rdsIds?.includes(item?.name)
            ) {
              acc.rdsIds.push(item.name);
            } else if (
              item.type === "lambda" &&
              !acc?.lambdaIds?.includes(item?.name)
            ) {
              acc.lambdaIds.push(item.name);
            } else if (
              item.type === "eks" &&
              !acc?.eksIds?.includes(item?.name)
            ) {
              acc.eksIds.push(item.name);
            }
            return acc;
          },
          {
            provider: null,
            sourceRegion: null,
            targetRegion: null,
            resourceSuffix: null,
            projectName : null,
            ec2Ids: [],
            rdsIds: [],
            lambdaIds: [],
            eksIds: [],
          }
        );
      console.log(awsFailoverScriptRequest, "awsFailoverScriptRequest");

      const gcpFailoverScriptRequest = allData
        .filter((item) => updatedRows[item.id] && item.id && check)
        .reduce(
          (acc, item) => {
            // Set general config only once
            if (!acc.provider) {
              console.log("provider");
              acc.provider = "gcp";
              acc.sourceRegion = item.location?.toLowerCase() || "us-east-2"; // fallback if location missing
              acc.targetRegion = "us-central1"; // you can also make this dynamic if needed
              acc.resourceSuffix = "-drdd";
              acc.sourceProjectId = "drd-project-462808";
              acc.sourceProjectName = selectedValue;
            }
            console.log(item?.name, "itemName");

            // Push resources based on type
            if (
              item.type === "computeEngine" &&
              !acc?.gceIds?.includes(item?.name)
            ) {
              acc.gceIds.push(item.name);
              acc.gceSourceZone = "-b";
              acc.gceTargetZone = "-a";
            } else if (
              item.type === "sql" &&
              !acc?.sqlIds?.includes(item?.name)
            ) {
              acc.sqlIds.push(item.name);
            } else if (
              item.type === "gke" &&
              !acc?.gkeIds?.includes(item?.name)
            ) {
              acc.gkeIds.push(item.name);
            }
            return acc;
          },
          {
            provider: null,
            sourceRegion: null,
            targetRegion: null,
            resourceSuffix: null,
            sourceProjectId: "",
            sourceProjectName: "",
            gceIds: [],
            sqlIds: [],
            gkeIds: [],
            gceSourceZone: "",
            gceTargetZone: "",
          }
        );
      console.log(gcpFailoverScriptRequest, "gcpFailoverScriptRequest");

      const payload = isAzure
        ? anFailoverScriptRequest
        : isAws
        ? awsFailoverScriptRequest
        : isGcp
        ? gcpFailoverScriptRequest
        : "";

      // Check if any values are selected
      const isAnySelected = Object.values(updatedRows).some((val) => val);

      if (isAnySelected) {
        if (!check) {
          setPayload({
            subscriptionId: "d6240a3c-34a4-4a5c-955b-06228bf34ca8",
            sqlFailOverRequest,
            vmFailOverRequest,
            functionAppFailOverRequests,
            webAppFailOverRequests,
          });
        } else {
          setScriptPayload({
            ...payload,
          });
        }
      } else {
        // If no values are selected, reset the payload to null
        setPayload(null);
        setScriptPayload(null);
      }

      console.log(
        {
          subscriptionId: "d6240a3c-34a4-4a5c-955b-06228bf34ca8",
          sqlFailOverRequest,
          vmFailOverRequest,
          functionAppFailOverRequests,
          webAppFailOverRequests,
        },
        "Updated Payload"
      );

      return updatedRows;
    });
  };

  const startFailover = async () => {
    console.log(payload, "payload");

    try {
      if (
        !payload &&
        !scriptPayload
        // (
        //   !payload.sqlFailOverRequest.length &&
        //   !payload.vmFailOverRequest.length &&
        //   !payload.functionappPayload.length
        // )
      ) {
        toast.error("No items selected for failover.");
        return;
      }

      // Reset progress and set failover as active
      // setProgress(0); // Reset progress to 0 when failover starts
      setIsFailoverActive(true); // Mark failover as active

      // Create a manual progress interval to update the progress slowly
      // const progressInterval = setInterval(() => {
      //   // setProgress((prev) => {
      //   //   // Only increase progress if it's not already at 100%
      //   //   if (prev < 96) {
      //   //     return prev + 2; // Adjust this value for slower progress
      //   //   } else {
      //   //     clearInterval(progressInterval); // Stop progress when 100% is reached
      //   //     return 98; // Ensure it finishes at 100%
      //   //   }
      //   // });
      // }, 656); // Adjust the interval for slower progress (500ms)

      // Perform conditional API calls
      let response = null;
      let scriptResponse = null;

      if (payload) {
        response = await axios.post(FAIL_URL, payload);
        if (response?.status === 200) {
          console.log("Failover process started successfully (Payload API)");
          // setProgress(64); // Update progress
          setLeftWidth(50); // Example for UI updates
          setPayload(null); // Clear payload state
        } else {
          console.error("Failed to start failover, status:", response?.status);
        }
      }

      if (scriptPayload) {
        scriptResponse = await axios.post(FAIL_URL_SCRIPT, scriptPayload);
        if (scriptResponse?.status === 200 || scriptResponse?.status === 504) {
          console.log("Failover process started successfully (Script API)");
          // setProgress(84); // Update progress
          setLeftWidth(50); // Example for UI updates
          // Clear script payload state
        } else {
          console.error(
            "Failed to execute script, status:",
            scriptResponse?.status
          );
        }
      }
    } catch (error) {
      console.error("Error during failover API call:", error);
      // Handle error case if API call fails
    }
  };

  //const handleViewClick = (row) => {
  //setSelectedPop(row);
  //setShowModal(true);
  //};

  const openModal = (row) => {
    setSelectedDatabase(row);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedDatabase(null);
  };

  const handleOpenRto = async (row) => {
    try {
      setShowModal(true);
      const splitId = row?.id.split("/");
      const subId = splitId[2];
      const resId = row.id;

      // Get original resourceGroupId from row
      let resourceGroupId = splitId.slice(0, 5).join("/");

      // Define suffixes based on provider
      const suffixMap = {
        azure: "-cus-dr",
        aws: "-dr",
        gcp: "-drdd",
      };

      // Append suffix only if not already present
      const suffix = suffixMap[provider?.toLowerCase()] || "";
      if (suffix && !resourceGroupId.endsWith(suffix)) {
        resourceGroupId = resourceGroupId + suffix;
      }

      const payload = {
        provider: provider.toLowerCase(),
        subscriptionId: subId,
        workspaceId: "d0cc072c-0634-418e-b049-8061a60ae814",
        projectId: resourceGroupId,
        resourceId: resId,
        localTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // e.g. "Asia/Kolkata"
        timeSpan: "P1D",
      };

      const data = await fetchRtoData(payload);
      const enrichedData = {
        ...data,
        sourceName: row?.name,
        targetName: row?.name + suffix,
      };

      setRtoData(enrichedData);
    } catch (err) {
      console.error("Error fetching RTO:", err);
    }
  };
  const suffixMap = {
    azure: "cus-dr",
    aws: "-dr",
    gcp: "-drdd",
  };

  const suffix = suffixMap[provider.toLowerCase()] || "";

  const renderTable = (data, isLeftTable, isRightService, checkData) => {
    // Empty types render nothing; a single message is shown per side below
    if (data.length === 0) return null;
    const fnBorder = data.some(
      (row) =>
        row?.type?.toLowerCase() ===
        `${
          provider?.toLowerCase() === "azure"
            ? "functionapp"
            : provider?.toLowerCase() === "aws"
            ? "lambda"
            : "cloudfunction"
        }`
    );
    const webBorder = data.some(
      (row) =>
        row?.type?.toLowerCase() ===
        `${
          provider?.toLowerCase() === "azure"
            ? "appservice"
            : provider?.toLowerCase() === "aws"
            ? "elasticbeanstalk"
            : ""
        }`
    );
    const sqlBorder = data.some(
      (row) =>
        row?.type?.toLowerCase() ===
        `${
          provider?.toLowerCase() === "azure"
            ? "sqlservers"
            : provider?.toLowerCase() === "aws"
            ? "rds"
            : "sql"
        }`
    );
    const mySqlBorder = data.some(
      (row) => row?.type?.toLowerCase() === "mysql server"
    );
    const postgreSqlBorder = data.some(
      (row) => row?.type?.toLowerCase() === "postgresql server"
    );
    const vmBorder = data.some(
      (row) =>
        row?.type?.toLowerCase() ===
        `${
          provider?.toLowerCase() === "azure"
            ? "virtualmachine"
            : provider?.toLowerCase() === "aws"
            ? "ec2"
            : "computeengine"
        }`
    );
    const lgBorder = data.some(
      (row) =>
        row.type ===
        `${
          provider?.toLowerCase() === "azure"
            ? "logicapp"
            : provider?.toLowerCase() === "aws"
            ? "StepFunctions"
            : "Workflow"
        }`
    );

    const kubernetesBorder = data.some(
      (row) =>
        row.type ===
        `${
          provider?.toLowerCase() === "azure"
            ? "kubernetes"
            : provider?.toLowerCase() === "aws"
            ? "eks"
            : "gke"
        }`
    );

    return (
      <div class="table-responsive ">
        {data.length > 0 && (
          <div className="align-items-center justify-content-center">
            {!isRightService && (
              <div
                className={`vertical-button ${
                  fnBorder ? "border-function functionbg" : ""
                } ${webBorder ? "border-web webbg" : ""} ${
                  sqlBorder ? "border-sql sqlbg" : ""
                }${mySqlBorder ? "border-mysql mysqlbg" : ""}${
                  postgreSqlBorder ? "border-postgresql postgresqlbg" : ""
                } ${vmBorder ? "border-vm vmbg" : ""} ${
                  lgBorder ? "border-lg lgbg" : ""
                } ${kubernetesBorder ? "border-kub kubbg" : ""}`}
              >
                {fnBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "Functionapp"
                        : provider.toLowerCase() === "aws"
                        ? "Lambda"
                        : "Cloud Function"
                    }`
                  : webBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "Appservice"
                        : provider.toLowerCase() === "aws"
                        ? "Beanstalk"
                        : ""
                    }`
                  : sqlBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "SQL"
                        : provider.toLowerCase() === "aws"
                        ? "RDS"
                        : "SQL"
                    }`
                  : mySqlBorder
                  ? "MySQL"
                  : postgreSqlBorder
                  ? "PostgreSQL"
                  : vmBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "Virtual machine"
                        : provider.toLowerCase() === "aws"
                        ? "EC2"
                        : "Compute Engine"
                    }`
                  : lgBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "Logicapp"
                        : provider.toLowerCase() === "aws"
                        ? "Step Function"
                        : "Workflow"
                    }`
                  : kubernetesBorder
                  ? `${
                      provider.toLowerCase() === "azure"
                        ? "Kubernetes"
                        : provider.toLowerCase() === "aws"
                        ? "EKS"
                        : "GKE"
                    }`
                  : "data"}
              </div>
            )}
            <Table
              hover
              className={`table tablebgdr mb-0 ${
                fnBorder ? "border-function" : ""
              } ${webBorder ? "border-web" : ""} ${
                sqlBorder ? "border-sql" : ""
              } ${mySqlBorder ? "border-mysql" : ""}${
                postgreSqlBorder ? "border-postgresql" : ""
              } ${vmBorder ? "border-vm" : ""} ${lgBorder ? "border-lg" : ""} ${
                kubernetesBorder ? "border-kub" : ""
              } ${isRightService ? "m-30" : ""}`}
            >
              {(data.some(
                (row) =>
                  row?.type?.toLowerCase() ===
                  `${
                    provider?.toLowerCase() === "azure"
                      ? "functionapp"
                      : provider?.toLowerCase() === "aws"
                      ? "lambda"
                      : "cloudfunction"
                  }`
              ) ||
                checkData) && (
                <thead className="tablebg">
                  <tr>
                    <th className="text-uppercase tablebgtext text-center"></th>
                    <th className="text-uppercase tablebgtext text-center"></th>
                    <th className="text-uppercase tablebgtext">Name</th>

                    <th className="text-uppercase tablebgtext text-center">
                      Location
                    </th>
                    <th className="text-uppercase tablebgtext text-center">
                      Status
                    </th>
                    {provider.toLowerCase() === "azure" && (
                      <th className="text-uppercase tablebgtext"></th>
                    )}
                  </tr>
                </thead>
              )}
              <tbody>
                {data.length > 0 ? (
                  data.map((row, index) => {
                    const disabled = row?.replicationRole === "Disabled";
                    const enabled =
                      row?.replicationRole === "Enabled" ||
                      row?.replicationRole?.toLowerCase() === "active";
                    const isReady = row?.replicationRole === "Ready";
                    const isSecondary =
                      row?.replicationRole === "Secondary" ||
                      row?.replicationRole?.toLowerCase() === "stopped";
                    const deallocated = row?.replicationRole === "deallocated";
                    const isPrimary =
                      row?.replicationRole === "Primary" ||
                      row?.replicationRole.toLowerCase() === "running" ||
                      row?.replicationRole.toLowerCase() === "available" ||
                      row?.replicationRole.toLowerCase() === "runnable";
                    const isActiveNothing = row?.replicationRole === "-";
                    const Stopping =
                      row?.replicationRole.toLocaleLowerCase() ===
                        "stopping..." || "stopping";
                    const sec =
                      typeof row?.recoveryVmInfo === "object" &&
                      row?.recoveryVmInfo !== null &&
                      Object.keys(row?.recoveryVmInfo).length === 0;
                    const sqlType =
                      row?.type ===
                      `${
                        provider.toLowerCase() === "azure"
                          ? "sqlservers"
                          : provider.toLowerCase() === "aws"
                          ? "rds"
                          : "sql"
                      }`;
                    const mySqlType = row?.type === "mysql server";
                    const postgreSqlType = row?.type === "postgresql server";

                    const isAzure = provider.toLowerCase() === "azure";
                    console.log(row, "rowData")
                    return (
                      <tr
                        key={index}
                        className={`${
                          isSecondary || disabled ? "table-row-secondary" : ""
                        } ${isPrimary || enabled ? "table-row-selected" : ""} ${
                          row.rowCheck ? "table-row-nothing" : ""
                        }`}
                      >
                        {/* <td
                          className="first-border border-mild"
                          style={{
                            width: "30px",
                            maxWidth: "30px",
                          }}
                        >
                          <input
                            type="checkbox"
                            disabled={
                              isSecondary ||
                              sec ||
                              disabled ||
                              row.checkDis ||
                              isFailoverActive
                            }
                            checked={!!(selectedRow && selectedRow[row?.id])}
                            onChange={() =>
                              handleCheckboxChange(row?.id, row?.rowCheck)
                            }
                            className={
                              row.checkDis || row.checkHide
                                ? "d-none"
                                : "d-block"
                            }
                          />
                        </td> */}
                        <td
                          className="first-border border-mild"
                          style={{ width: "30px", maxWidth: "30px" }}
                        >
                          {(row.checkDis || row.checkHide) &&
                          !row.name.endsWith("cus-dr") &&
                          isAzure &&
                          (row.type === "virtualmachine" ||
                            row.type === "kubernetes") ? (
                            <>
                              <i
                                className="fas fa-clock text-primary"
                                title="RTO"
                                onClick={() => handleOpenRto(row)}
                                style={{ fontSize: "20px", cursor: "pointer" }}
                              ></i>

                              {/* Stepper with Modal inside */}
                              <DrStepper
                                showModal={showModal}
                                onClose={() => setShowModal(false)}
                                data={rtoData}
                              />
                            </>
                          ) : !row.name.endsWith(suffix) && !row?.checkHide ? (
                            <input
                              type="checkbox"
                              disabled={
                                isSecondary ||
                                sec ||
                                disabled ||
                                row.checkDis ||
                                isFailoverActive
                              }
                              checked={!!(selectedRow && selectedRow[row?.id])}
                              onChange={() =>
                                handleCheckboxChange(row?.id, row?.rowCheck)
                              }
                              className="d-block"
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <>
                          <td
                            className="border-mild"
                            style={{
                              width: "50px",
                              maxWidth: "50px",
                            }}
                          >
                            {/* {row?.type ? row?.type : "-"} */}
                            <img
                              src={`${
                                fnBorder
                                  ? provider?.toLowerCase() === "azure"
                                    ? FunLogo
                                    : provider?.toLowerCase() === "aws"
                                    ? Lambda
                                    : CloudFunction
                                  : webBorder
                                  ? provider?.toLowerCase() === "azure"
                                    ? WebLogo
                                    : provider?.toLowerCase() === "aws"
                                    ? beanStalk
                                    : ""
                                  : sqlBorder
                                  ? provider?.toLowerCase() === "azure"
                                    ? SqlLogo
                                    : provider?.toLowerCase() === "aws"
                                    ? RDS
                                    : SQL
                                  : mySqlBorder
                                  ? MySqlImg
                                  : postgreSqlBorder
                                  ? PostgresqlImg
                                  : vmBorder
                                  ? provider?.toLowerCase() === "azure"
                                    ? VmLogo
                                    : provider?.toLowerCase() === "aws"
                                    ? ec2
                                    : ComputeEngine
                                  : kubernetesBorder
                                  ? provider?.toLowerCase() === "azure"
                                    ? kubernetes
                                    : provider?.toLowerCase() === "aws"
                                    ? eks
                                    : gke
                                  : lgBorder
                                  ? lgLogo
                                  : ""
                              } `}
                              alt="logo"
                              width={30}
                              height={30}
                            ></img>
                          </td>
                          <td
                            className="border-mild fw-bold ps-2"
                            style={{
                              width: "156px",
                              maxWidth: "156px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Tooltip
                              // options
                              title={row?.name}
                              position="top"
                              arrow={true}
                              animation="fade" // You can experiment with different animations
                              theme="dark"
                            >
                              <p className="mb-0 text-lowercase">
                                {row?.name?.length > 20
                                  ? row?.name.substring(0, 20) + ".."
                                  : row?.name}
                              </p>
                            </Tooltip>
                          </td>

                          <td
                            className="border-mild"
                            style={{
                              width: "100px",
                              maxWidth: "100px",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              textAlign: "center",
                            }}
                          >
                            {row?.location
                              ? row?.location?.toLowerCase().replace(/\s+/g, "")
                              : "-"}
                          </td>

                          <td
                            className="border-mild text-center"
                            style={{
                              width: "180px",
                            }}
                          >
                            {isFailoverActive &&
                            selectedRow[row.id] &&
                            !row.checkDis ? (
                              <SpinnerSquare />
                            ) : (
                              <span
                                className={`pill mb-0 text-center ${
                                  isPrimary || isReady || enabled
                                    ? "bgsuccess"
                                    : isSecondary || disabled || deallocated
                                    ? "bgdanger"
                                    : isActiveNothing
                                    ? "bgsecondary"
                                    : Stopping
                                    ? "bgstopping"
                                    : ""
                                }`}
                              >
                                {isPrimary ||
                                isReady ||
                                enabled ||
                                isSecondary ||
                                disabled ||
                                deallocated ||
                                isActiveNothing ||
                                Stopping ? (
                                  <FaCircle
                                    className={`me-2 fs-10 ${
                                      isPrimary || isReady || enabled
                                        ? "textsuccess"
                                        : isSecondary || disabled || deallocated
                                        ? "textdanger"
                                        : isActiveNothing
                                        ? "text-secondary"
                                        : Stopping
                                        ? "text-stopping"
                                        : ""
                                    }`}
                                  />
                                ) : (
                                  ""
                                )}

                                {isActiveNothing
                                  ? "---------"
                                  : row?.replicationRole
                                      .charAt(0)
                                      .toUpperCase() +
                                      row?.replicationRole
                                        .slice(1)
                                        .toLowerCase() || "---------"}
                              </span>
                            )}
                          </td>
                          {provider.toLowerCase() === "azure" && (
                            <td
                              className="border-mild text-center"
                              style={{
                                width: "30px",
                                maxWidth: "30px",
                              }}
                            >
                              {(row?.type ===
                                `${
                                  provider.toLowerCase() === "azure"
                                    ? "functionapp"
                                    : provider.toLowerCase() === "aws"
                                    ? "lambda"
                                    : ""
                                }` ||
                                row?.type ===
                                  `${
                                    provider.toLowerCase() === "azure"
                                      ? "appservice"
                                      : provider.toLowerCase() === "aws"
                                      ? "elasticbeanstalk"
                                      : ""
                                  }`) &&
                                (row?.replicationRole === "Enabled" ||
                                  row?.replicationRole === "Running" ||
                                  row?.replicationRole.toLowerCase() ===
                                    "active" ||
                                  row?.replicationRole.toLowerCase() ===
                                    "ready") && (
                                  <OverlayTrigger
                                    trigger="click"
                                    placement="top"
                                    rootClose
                                    overlay={
                                      <Popover id="popover-basic">
                                        <Popover.Header>
                                          <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={
                                              row?.targetUrl &&
                                              row?.targetUrl.replace(
                                                "",
                                                `https://`
                                              )
                                            }
                                            className="cursor-pointer"
                                          >
                                            <div className="d-flex align-items-center">
                                              <RiGlobalLine />{" "}
                                              <span
                                                className="text-dark ms-1"
                                                style={{ fontSize: "12px" }}
                                              >
                                                {" "}
                                                DNS Name{" "}
                                              </span>
                                            </div>
                                          </a>
                                        </Popover.Header>
                                      </Popover>
                                    }
                                  >
                                    <div
                                      onClick={handleClick}
                                      className="cursor-pointer"
                                    >
                                      <SlOptionsVertical className="text-primarydark" />
                                    </div>
                                  </OverlayTrigger>
                                )}
                              {(row?.type ===
                                `${
                                  provider.toLowerCase() === "azure"
                                    ? "functionapp"
                                    : provider.toLowerCase() === "aws"
                                    ? "lambda"
                                    : ""
                                }` ||
                                row?.type ===
                                  `${
                                    provider.toLowerCase() === "azure"
                                      ? "appservice"
                                      : provider.toLowerCase() === "aws"
                                      ? "elasticbeanstalk"
                                      : ""
                                  }`) &&
                                (row?.replicationRole === "Disabled" ||
                                  row.replicationRole === "-" ||
                                  row.replicationRole === "Stopped") && (
                                  <div className="cursor-none iconaction ">
                                    <div className="disabled-btn iconaction ">
                                      <SlOptionsVertical className="text-primarydark" />
                                    </div>
                                  </div>
                                )}
                              {row?.replicationRole?.toLowerCase() ===
                                "running" &&
                                row?.type ===
                                  `${
                                    provider.toLowerCase() === "azure"
                                      ? "virtualmachine"
                                      : provider.toLowerCase() === "aws"
                                      ? "ec2"
                                      : ""
                                  }` && (
                                  <Tooltip
                                    // options
                                    title={row?.ipAddress}
                                    position="top"
                                    arrow={true}
                                    animation="fade" // You can experiment with different animations
                                    theme="dark"
                                  >
                                    <div className="cursor-pointer">
                                      <SlOptionsVertical className="text-primarydark" />
                                    </div>
                                  </Tooltip>
                                )}
                              {(row?.replicationRole?.toLowerCase() ===
                                "stopped" ||
                                row.replicationRole === "-") &&
                                row?.type ===
                                  `${
                                    provider.toLowerCase() === "azure"
                                      ? "virtualmachine"
                                      : provider.toLowerCase() === "aws"
                                      ? "ec2"
                                      : ""
                                  }` && (
                                  <div className="cursor-none iconaction ">
                                    <div className="disabled-btn iconaction ">
                                      <SlOptionsVertical className="text-primarydark" />
                                    </div>
                                  </div>
                                )}
                              {(sqlType || mySqlType || postgreSqlType) &&
                                isAzure && (
                                  <div className="relative inline-block text-left w-full h-full">
                                    <Tooltip
                                      title="View Databases"
                                      position="top"
                                      arrow={true}
                                      animation="fade"
                                      theme="dark"
                                    >
                                      <span
                                        className="text-primary cursor-pointer"
                                        onClick={() => openModal(row)}
                                      >
                                        <SlOptionsVertical className="text-primarydark" />
                                      </span>
                                    </Tooltip>
                                  </div>
                                )}
                            </td>
                          )}
                        </>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={isLeftTable ? 7 : 6}
                      className="text-center border-mild"
                    >
                      No resources found in this group
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    );
  };
  const options = resourceGroup
    ?.filter((option) => !option?.name?.endsWith("-dr"))
    .map((option) => ({
      value: option?.name,
      label: option?.projectName || `Tag-Undefined(${option?.name})`,
    }));

  // Handler for selection change
  const onChange = (selectedOption) => {
    if (selectedOption?.value !== selectedValue) {
      handleSelectChange({ target: { value: selectedOption?.value } });
      setSqlRightData([]);
      setVmRightData([]);
      setSqlData([]);
      setVmData([]);
      setFnAppRightData([]);
      setWebAppRightData([]);
    }
  };

  const [show, setShow] = useState(false);

  const handleClick = () => setShow(!show);

  return (
    <>
      <div className="card-header d-flex justify-content-between align-items-center">
        {/* <p className="mb-0 fs-5 fw-bold ms-2 text-primarydark "> */}
        <div>
          <label>
            {provider.toLowerCase() === "azure"
              ? "Select the resource group"
              : "Select the Project"}
          </label>
          <Select
            options={options}
            value={options.find((option) => option.value === selectedValue)}
            onChange={onChange}
            disabled={loading}
            placeholder="Select an option"
            className="react-select-container"
            classNamePrefix="react-select"
            menuPortalTarget={document.body} // Render the dropdown outside the card
            isLoading={projectListLoading}
            noOptionsMessage={() =>
              projectListLoading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    color: "grey",
                  }}
                >
                  <span className="spinner" /> Loading...
                </div>
              ) : (
                "No options available"
              )
            }
            getOptionLabel={(data) =>
              data.label.startsWith("Tag-Undefined") ? (
                <span>
                  <span style={{ color: "grey" }}>Tag-Undefined</span>
                  <span style={{ color: "black" }}>
                    {data.label.replace("Tag-Undefined", "")}
                  </span>
                </span>
              ) : (
                data.label
              )
            }
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Ensure it's on top
              menu: (base) => ({
                ...base,
                whiteSpace: "nowrap", // Prevents wrapping of individual options
                overflowX: "hidden", // Hides any x-scroll
                width: "max-content", // Allows content to grow without forcing horizontal scroll
                minWidth: "200px", // Set a reasonable minimum width
              }),
              menuList: (base) => ({
                ...base,
                maxWidth: "100%", // Ensures the list doesn't exceed the menu width
                maxHeight: "350px",
              }),
              singleValue: (base, { data }) => ({
                ...base,
                display: "flex",
                alignItems: "center",
                color: "black",
              }),
              loadingIndicator: (base) => ({
                ...base,
                color: "#007bff", // Replace with your primary color (e.g., Bootstrap Primary)
              }),
            }}
          />
        </div>
        <div className="d-flex justify-content-between">
          {/* <button className="btn d-flex" type="submit">
              <div className="rounded-circle bordercircle bg-success">
                {" "}
                <FaCircle className="text-success-primary border-success" />
              </div>{" "}
              <div className="ms-2">Primary</div>
            </button>
            <button className="btn d-flex" type="submit">
              <div className="rounded-circle bordercircle bg-secondary">
                <FaCircle className="text-success-secondary" />
              </div>
              <div className="ms-2">Secondary</div>
            </button> */}
          <button
            className="btndr-hover color-1 position-relative"
            onClick={startFailover}
            disabled={isFailoverActive}
          >
            {isFailoverActive ? "In progress" : "Initiate DR"}
            <RiSwap2Fill className="ms-2" />
          </button>
        </div>
      </div>

      <Container
        fluid
        className={`d-flex pb-5 initiate-table ${
          loading ? "justify-content-between" : "justify-content-center"
        }`}
      >
        <Split
          direction="horizontal"
          sizes={[leftWidth, 100 - leftWidth]}
          className="d-flex w-96 mt-2"
        >
          <div>
            <div>
              {loading ? (
                <div className="d-flex justify-content-center my-4">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                renderTable(fnAppData, true, false)
                // Call the renderTable function directly
              )}
            </div>

            <div className={`${webAppData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(webAppData, true, false, fnAppData.length === 0)
                // Call the renderTable function directly
              )}
            </div>

            <div className={`${sqlData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  sqlData,
                  true,
                  false,
                  fnAppData.length === 0 && webAppData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div className={`${mySqlData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  mySqlData,
                  true,
                  false,
                  fnAppData.length === 0 &&
                    webAppData.length === 0 &&
                    sqlData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div className={`${postgresqlData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  postgresqlData,
                  true,
                  false,
                  fnAppData.length === 0 &&
                    webAppData.length === 0 &&
                    sqlData.length === 0 &&
                    mySqlData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>

            <div className={`${vmData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  vmData,
                  true,
                  false,
                  fnAppData.length === 0 &&
                    webAppData.length === 0 &&
                    sqlData.length === 0 &&
                    mySqlData.length === 0 &&
                    postgresqlData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div className={`${logicData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  logicData,
                  true,
                  false,
                  fnAppData.length === 0 &&
                    webAppData.length === 0 &&
                    sqlData.length === 0 &&
                    mySqlData.length === 0 &&
                    postgresqlData.length === 0 &&
                    vmData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div className={`${kubernetesData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  kubernetesData,
                  true,
                  false,
                  fnAppData.length === 0 &&
                    webAppData.length === 0 &&
                    sqlData.length === 0 &&
                    mySqlData.length === 0 &&
                    postgresqlData.length === 0 &&
                    vmData.length === 0 &&
                    logicData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            {!loading &&
              [
                fnAppData,
                webAppData,
                sqlData,
                mySqlData,
                postgresqlData,
                vmData,
                logicData,
                kubernetesData,
              ].every((d) => d.length === 0) && (
                <div className="no-resources-message">
                  <FaRegFolderOpen className="no-resources-icon" />
                  <span>No resources found in this group</span>
                </div>
              )}
          </div>
          <div className="">
            <div>
              {loading ? (
                <div className="d-flex justify-content-center my-4">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                renderTable(
                  fnAppRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true
                ) // Call the renderTable function directly
              )}
            </div>
            <div
              className={`${webAppRightData.length !== 0 ? "mt-3" : "mt-0"}`}
            >
              {loading ? (
                <></>
              ) : (
                renderTable(
                  webAppRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true,
                  fnAppRightData.length === 0
                ) // Call the renderTable function directly
              )}
            </div>
            <div className={`${sqlRightData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  sqlRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true,
                  fnAppRightData.length === 0 && webAppRightData.length === 0
                ) // Call the renderTable function directly
              )}
            </div>
            <div className={`${mySqlRightData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  mySqlRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true,
                  fnAppRightData.length === 0 &&
                    webAppRightData.length === 0 &&
                    sqlRightData.length === 0
                ) // Call the renderTable function directly
              )}
            </div>
            <div
              className={`${
                postgresqlRightData.length !== 0 ? "mt-3" : "mt-0"
              }`}
            >
              {loading ? (
                <></>
              ) : (
                renderTable(
                  postgresqlRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true,
                  fnAppRightData.length === 0 &&
                    webAppRightData.length === 0 &&
                    sqlRightData.length === 0 &&
                    mySqlRightData.length === 0
                ) // Call the renderTable function directly
              )}
            </div>
            <div className={`${vmRightData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  vmRightData.filter(
                    (item, index, self) =>
                      index === self.findIndex((t) => t.name === item.name)
                  ),
                  true,
                  true,
                  fnAppRightData.length === 0 &&
                    webAppRightData.length === 0 &&
                    sqlRightData.length === 0 &&
                    mySqlRightData.length === 0 &&
                    postgresqlRightData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div className={`${logicRightData.length !== 0 ? "mt-3" : "mt-0"}`}>
              {loading ? (
                <></>
              ) : (
                renderTable(
                  logicRightData,
                  true,
                  true,
                  fnAppRightData.length === 0 &&
                    webAppRightData.length === 0 &&
                    sqlRightData.length === 0 &&
                    mySqlRightData.length === 0 &&
                    postgresqlRightData.length === 0 &&
                    vmRightData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            <div
              className={`${
                kubernetesRightData.length !== 0 ? "mt-3" : "mt-0"
              }`}
            >
              {loading ? (
                <></>
              ) : (
                renderTable(
                  kubernetesRightData,
                  true,
                  true,
                  fnAppRightData.length === 0 &&
                    webAppRightData.length === 0 &&
                    sqlRightData.length === 0 &&
                    mySqlRightData.length === 0 &&
                    postgresqlRightData.length === 0 &&
                    vmRightData.length === 0 &&
                    logicRightData.length === 0
                )
                // Call the renderTable function directly
              )}
            </div>
            {!loading &&
              [
                fnAppRightData,
                webAppRightData,
                sqlRightData,
                mySqlRightData,
                postgresqlRightData,
                vmRightData,
                logicRightData,
                kubernetesRightData,
              ].every((d) => d.length === 0) && (
                <div className="no-resources-message">
                  <FaRegFolderOpen className="no-resources-icon" />
                  <span>No resources found in this group</span>
                </div>
              )}
          </div>
        </Split>
      </Container>
      <DatabaseModal
        isOpen={showModal}
        onClose={closeModal}
        data={selectedDatabase}
      />
      {/* {isFailoverActive && (
          <>
            <ProgressBar
              animated
              now={progress}
              label={`${progress}%`}
              className="mt-3 w-50 mx-auto"
            />
            <p className="mt-2 mx-auto">
              {progress < 100
                ? "Please wait... Failover in progress..."
                : "Failover completed successfully!"}
            </p>
          </>
        )} */}
    </>
  );
};

export default TwoCardSlider;
